/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Router } from '@angular/router';
import { Validators, FormControl, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material';

import { IBaseView } from '../../../icemedx-lib/src/components/baseview.component';
import {
  IcecontrolSettings,
  iceColumnDefinition,
  IceResponsiveMattableSettings,
  IcepanelgroupSettings,
  IcepanelsectionSettings,
  IcepanelcontainerSettings,
  SECTION_CONTROL_ALIGNMENT
} from 'projects/icemedx-lib/src/components/models/icesettings';

import { IceEntity } from 'projects/icemedx-lib/src/models/core/IceEntity';
import { provider } from 'projects/icemedx-lib/src/models/domain/provider';
import { entity } from 'projects/icemedx-lib/src/models/common/entity';
import { contact } from 'projects/icemedx-lib/src/models/common/contact';
import { address } from '../../../icemedx-lib/src/models/common/address';

import { AppService } from './app.service';
import { IceNavService } from '../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { LoginService } from '../../../icemedx-lib/src/login/login.service';
import { DomainService } from 'projects/icemedx-lib/src/services/domain/domain.service';
import { MessageService } from '../../../icemedx-lib/src/services/message/message.service';
import { VendorService } from '../../../icemedx-lib/src/services/vendor/vendor.service';
import { ProviderService } from '../../../icemedx-lib/src/services/provider/provider.service';
import { PharmacyService } from '../../../icemedx-lib/src/services/pharmacy/pharmacy.service';
import { PayerService } from '../../../icemedx-lib/src/services/payer/payer.service';
import { Iceutility } from 'projects/icemedx-lib/src/services/iceutility';
import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';
import { userTypes } from 'projects/icemedx-lib/src/login/login.config';
import { connectionparameters } from '../../../icemedx-lib/src/models/messages/connectionparameters';
import { transtype } from '../../../icemedx-lib/src/models/domain/transtype';
import { transtypereference } from '../../../icemedx-lib/src/models/messages/transtypereference';
import { identification } from '../../../icemedx-lib/src/models/common/identification';
import { MedicalcodesService } from '../../../icemedx-lib/src/services/medicalcodes/medicalcodes.service';
import { vendor } from '../../../icemedx-lib/src/models/domain/vendor';
import { subscriptionobject } from '../../../icemedx-lib/src/models/domain/subscription';
import { licenseobject } from '../../../icemedx-lib/src/models/domain/license';
import { basecode } from '../../../icemedx-lib/src/models/ehr/subs/basecode';
import { orderobject } from '../../../icemedx-lib/src/models/domain/order';
import { orderdetailobject } from '../../../icemedx-lib/src/models/domain/orderdetail';
import { paymentrequest } from '../../../icemedx-lib/src/models/domain/paymentrequest';
import { logmessage } from '../../../icemedx-lib/src/models/system/logmessage';
import { LogReport } from '../../../icemedx-lib/src/models/system/LogReport';
import { OrderService } from '../../../icemedx-lib/src/services/orders/order.service';
import { provider_index } from '../../../icemedx-lib/src/models/domain/provider_index';
import { message } from '../../../icemedx-lib/src/models/messages/message';
import { SS } from '../../../icemedx-lib/src/models/system/ssmessage';

export class DomainProfile implements IBaseView {
  taxonomyCodeCtrl: IcecontrolSettings = null;
  countryCodeCtrl: IcecontrolSettings = null;
  currencyCodeCtrl: IcecontrolSettings = null;

  contactControls: IcecontrolSettings[] = [];
  idControls: IcecontrolSettings[];
  contactDataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  addressDataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  identificationDataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  subscriptionDataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  providersDataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);

  outboundParamsDataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  outboundTable: IceResponsiveMattableSettings = null;
  inboundParamsDataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  inboundTable: IceResponsiveMattableSettings = null;
  networkInfoDataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);

  idTable: IceResponsiveMattableSettings = null;
  subTable: IceResponsiveMattableSettings = null;
  idOptions: any[] = [];
  providerHIEUpdateDisable: boolean = false;
  surescriptsIDControls: any = {};

  newOutboundDomainTypeCtrl: IcecontrolSettings = null;
  newOutboundDomainNameCtrl: IcecontrolSettings = null;
  newOutboundDomainApplicaionCtrl: IcecontrolSettings = null;
  newOutboundDomainSection: IcepanelsectionSettings = null;
  newOutboundDomainSubmitSection: IcepanelsectionSettings = null;

  controlIDNewOutboundTypeofDomain: string = "NewOutboundTypeofDomain";
  controlIDNewOutboundNameofDomain: string = "NewOutboundNameofDomain";
  controlIDNewOutboundAppofDomain: string = "NewOutboundAppofDomain";
  controlIDAddNewOutboundConnection: string = "AddNewOutboundConnection";
  controlIDAddNewOutboundConnectionCancel: string = "AddNewOutboundConnectionCancel";
  controlIDTaxonomyCode: string = "TaxonomyCode";
  controlIDCountryCode: string = "CountryCode";
  controlIDCurrencyCode: string = "CurrencyCode";

  controlIDEditOutboundAppofDomain: string = "EditOutboundAppofDomain";
  controlIDEditOutboundTitle: string = "EditOutboundTitle";
  controlIDEditOutboundApplication: string = "EditOutboundApplication";
  controlIDEditOutboundCode: string = "EditOutboundCode";
  controlIDEditOutboundUsername: string = "EditOutboundUsername";
  controlIDEditOutboundPassword: string = "EditOutboundPassword";
  controlIDEditOutboundConnectionSave: string = "EditOutboundConnectionSave";
  controlIDEditOutboundConnectionCancel: string = "EditOutboundConnectionCancel";

  controlIDEditInboundConnectionTitle: string = "EditInboundConnectionTitle";
  controlIDEditInboundAppofDomain: string = "EditInboundAppofDomain";
  controlIDEditInboundCode: string = "EditInboundCode";
  controlIDEditInboundUsername: string = "EditInboundUsername";
  controlIDEditInboundPassword: string = "EditInboundPassword";
  controlIDEditInboundStatus: string = "EditInboundStatus";
  controlIDEditInboundTestMode: string = "EditInboundTestMode";
  controlIDEditInboundContactRequired: string = "EditInboundContactRequired";
  controlIDEditInboundMustContact: string = "EditInboundMustContact";
  controlIDEditInboundTestRequired: string = "EditInboundTestRequired";
  controlIDEditInboundParticipating: string = "EditInboundParticipating";
  controlIDEditInboundServer: string = "EditInboundServer";
  controlIDEditInboundFolder: string = "EditInboundFolder";
  controlIDEditInboundAppParam: string = "EditInboundAppParam";
  controlIDEditInboundDataFormat: string = "EditInboundDataFormat";
  controlIDEditInboundConnectionType: string = "EditInboundConnectionType";
  controlIDEditInboundProtocol: string = "EditInboundProtocol";
  controlIDEditInboundProtocolVersion: string = "EditInboundProtocolVersion";
  controlIDEditInboundProtocolAPI: string = "EditInboundProtocolAPI";
  controlIDEditInboundProtocolAPIVersion: string = "EditInboundProtocolAPIVersion";
  controlIDEditInboundConnectionSave: string = "EditInboundConnectionSave";
  controlIDEditInboundConnectionCancel: string = "EditInboundConnectionCancel";

  editOutboundTitleCtrl: IcecontrolSettings = null;
  editOutboundApplicationCtrl: IcecontrolSettings = null;
  editOutboundCodeCtrl: IcecontrolSettings = null;
  editOutboundUsernameCtrl: IcecontrolSettings = null;
  editOutboundPasswordCtrl: IcecontrolSettings = null;
  editOutboundDomainSubmitSection: IcepanelsectionSettings = null;
  editOutboundRow: any = null;

  editInboundConnectionTitleCtrl: IcecontrolSettings = null;
  editInboundDomainApplicaionCtrl: IcecontrolSettings = null;
  editInboundCodeCtrl: IcecontrolSettings = null;
  editInboundUsernameCtrl: IcecontrolSettings = null;
  editInboundPasswordCtrl: IcecontrolSettings = null;
  editInboundParticipatingCtrl: IcecontrolSettings = null;
  editInboundStatusCtrl: IcecontrolSettings = null;
  editInboundTestModeCtrl: IcecontrolSettings = null;
  editInboundContactRequiredCtrl: IcecontrolSettings = null;
  editInboundMustContactCtrl: IcecontrolSettings = null;
  editInboundTestRequiredCtrl: IcecontrolSettings = null;
  editInboundServerCtrl: IcecontrolSettings = null;
  editInboundFolderCtrl: IcecontrolSettings = null;
  editInboundAppParamCtrl: IcecontrolSettings = null;
  editInboundDataFormatCtrl: IcecontrolSettings = null;
  editInboundConnectionTypeCtrl: IcecontrolSettings = null;
  editInboundProtocolCtrl: IcecontrolSettings = null;
  editInboundProtocolVersionCtrl: IcecontrolSettings = null;
  editInboundProtocolAPICtrl: IcecontrolSettings = null;
  editInboundProtocolAPIVersionCtrl: IcecontrolSettings = null;
  editInboundDomainSubmitSection: IcepanelsectionSettings = null;
  editInboundRow: any = null;

  tableTagIdentification: string = "IdentificationTable";
  tableTagAddress: string = "AddressTable";
  tableTagContact: string = "ContactTable";
  tableTagSubscription: string = "SubscriptionTable";
  tableTagInboundNetworkConnectionTable: string = "InboundNetworkConnectionTable";
  tableTagOutboundNetworkConnectionTable: string = "OutboundNetworkConnectionTable";
  tableTagNetworkInformation: string = "NetworkInformationTable";
  tableTagPracticeProvider: string = "PracticeProviderTable";

  sectionTagEditIdentification: string = "IdentificationEditSection";
  sectionTagEditAddress: string = "AddressEditSection";
  sectionTagEditContact: string = "ContactEditSection";
  sectionTagSubscriptionPayment: string = "SubscriptionPayment";
  sectionTagPaymentReceipt: string = "PaymentReceipt";
  sectionTagEditNetworkInformation: string = "NetworkInformationEditSection";
  sectionTagEditPracticeProvider: string = "PracticeProviderEditSection";

  IDSelectType: string = "Select Type";
  TaxonomyCodeSelect: string = "Select Taxonomy";
  CountryCodeSelect: string = "Select Country";
  CurrencyCodeSelect: string = "Select Currency";

  profileContactName: string = "";
  profileCompanyName: string = "";
  profileAddress: string= "";
  profileCity: string= "";
  profileState: string= "";
  profileProvince: string= "";
  profilePostalCode: string = "";
  profileCountryCode: string= "";
  profilePhone: string= "";
  profileEmail: string= "";
  profileCurrencyCode: string = "";

  providerUpdateDisplayValue: string = "Update on Save";
  providerDisableDisplayValue: string = "Disable on Save";


  constructor(private appSvc: AppService,
    private domainSvc: DomainService,
    private vendorSvc: VendorService,
    private proSvc: ProviderService,
    private pharmSvc: PharmacyService,
    private payerSvc: PayerService, 
    private medCodeSvc: MedicalcodesService,
    public messageSvc: MessageService,
    private loginSvc: LoginService,
    private navSvc: IceNavService,
    private router: Router) {
  }

  getAppService(): AppService {
    return this.appSvc;
  }

  getDomainService(): DomainService {
    return this.domainSvc;
  }

  getProviderService(): ProviderService {
    return this.proSvc;
  }

  getVendorService(): VendorService {
    return this.vendorSvc;
  }

  getPharmacyService(): PharmacyService {
    return this.pharmSvc;
  }

  getPayerService(): PayerService {
    return this.payerSvc;
  }

  getLoginService(): LoginService {
    return this.loginSvc;
  }

  getNavService(): IceNavService {
    return this.navSvc;
  }

  getRouter(): Router {
    return this.router;
  }

  /////////////////////////////////
  // Outbound getters
  getNewOutboundDomainSection(): IcepanelsectionSettings {
    return this.newOutboundDomainSection;
  }

  getNewOutboundDomainSubmitSection(): IcepanelsectionSettings {
    return this.newOutboundDomainSubmitSection;
  }

  getNewOutboundDomainTypeControl(): IcecontrolSettings {
    return this.newOutboundDomainTypeCtrl;
  }

  getNewOutboundDomainApplicationControl(): IcecontrolSettings {
    return this.newOutboundDomainApplicaionCtrl;
  }

  getTaxonomyCodeControl(): IcecontrolSettings {
    return this.taxonomyCodeCtrl;
  }

  getEditOutboundDomainSubmitSection(): IcepanelsectionSettings {
    return this.editOutboundDomainSubmitSection;
  }

  getEditOutboundTitleControl(): IcecontrolSettings {
    return this.editOutboundTitleCtrl;
  }

  getEditOutboundApplicationControl(): IcecontrolSettings {
    return this.editOutboundApplicationCtrl;
  }

  getEditOutboundCodeControl(): IcecontrolSettings {
    return this.editOutboundCodeCtrl;
  }

  getEditOutboundUsernameControl(): IcecontrolSettings {
    return this.editOutboundUsernameCtrl;
  }

  getEditOutboundPasswordControl(): IcecontrolSettings {
    return this.editOutboundPasswordCtrl;
  }

  /////////////////////////////////
  // Inbound getters
  getEditInboundDomainSubmitSection(): IcepanelsectionSettings {
    return this.editInboundDomainSubmitSection;
  }

  getEditInboundConnectionTitleControl(): IcecontrolSettings {
    return this.editInboundConnectionTitleCtrl;
  }

  getEditInboundDomainApplicaionControl(): IcecontrolSettings {
    return this.editInboundDomainApplicaionCtrl;
  }

  getEditInboundCodeControl(): IcecontrolSettings {
    return this.editInboundCodeCtrl;
  }

  getEditInboundUsernameControl(): IcecontrolSettings {
    return this.editInboundUsernameCtrl;
  }

  getEditInboundPasswordControl(): IcecontrolSettings {
    return this.editInboundPasswordCtrl;
  }

  getEditInboundStatusControl(): IcecontrolSettings {
    return this.editInboundStatusCtrl;
  }

  getEditInboundParticipatingControl(): IcecontrolSettings {
    return this.editInboundParticipatingCtrl;
  }

  getEditInboundTestModeControl(): IcecontrolSettings {
    return this.editInboundTestModeCtrl;
  }

  getEditInboundContractRequiredControl(): IcecontrolSettings {
    return this.editInboundContactRequiredCtrl;
  }

  getEditInboundMustContactControl(): IcecontrolSettings {
    return this.editInboundMustContactCtrl;
  }

  getEditInboundTestRequiredControl(): IcecontrolSettings {
    return this.editInboundTestRequiredCtrl;
  }

  getEditInboundServerControl(): IcecontrolSettings {
    return this.editInboundServerCtrl;
  }

  getEditInboundFolderControl(): IcecontrolSettings {
    return this.editInboundFolderCtrl;
  }

  getEditInboundAppParamControl(): IcecontrolSettings {
    return this.editInboundAppParamCtrl;
  }

  getEditInboundDataFormatControl(): IcecontrolSettings {
    return this.editInboundDataFormatCtrl;
  }

  getEditInboundConnectionTypeControl(): IcecontrolSettings {
    return this.editInboundConnectionTypeCtrl;
  }

  getEditInboundProtocolControl(): IcecontrolSettings {
    return this.editInboundProtocolCtrl;
  }

  getEditInboundProtocolVersionControl(): IcecontrolSettings {
    return this.editInboundProtocolVersionCtrl;
  }

  getEditInboundProtocolAPIControl(): IcecontrolSettings {
    return this.editInboundProtocolAPICtrl;
  }

  getEditInboundProtocolAPIVersionControl(): IcecontrolSettings {
    return this.editInboundProtocolAPIVersionCtrl;
  }

  getProviderHIEUpdateDisable(): boolean {
    return this.providerHIEUpdateDisable;
  }

  getSurescriptControls(): any {
    return this.surescriptsIDControls;
  }

  hideNewOutboundConnectionSection(): void {
    let submitSec = this.getNewOutboundDomainSubmitSection();
    if (submitSec) submitSec.setShow(false);

    let ctrType: FormControl = this.getNewOutboundDomainTypeControl().getFormControl();
    if (ctrType != null) {
      ctrType.setValue(IceTypes.ACCOUNT_TYPE.actNone);
      this.setNewOutboundDomainNameList(IceTypes.ACCOUNT_TYPE.actNone);
      let ctrlApp: FormControl = this.getNewOutboundDomainApplicationControl().getFormControl();
      if (ctrlApp != null) ctrlApp.setValue(IceTypes.TRANSTYPE.itNone);
    }
  }

  hideEditOutboundConnectionSection(): void {
    let submitSec = this.getEditOutboundDomainSubmitSection();
    if (submitSec) submitSec.setShow(false);
  }

  hideEditInboundConnectionSection(): void {
    let submitSec = this.getEditInboundDomainSubmitSection();
    if (submitSec) submitSec.setShow(false);
  }

  viewName(domain: string, ents: entity[], defEntKey: string, useTaxonomyCodes: boolean, taxonomyCode: string, countryCode: basecode, currencyCode: basecode): IcecontrolSettings[] {
    let controls: IcecontrolSettings[] = [];
    try {
      let ent = <entity>this.domainSvc.getsubtreedata(ents, "entity_key", defEntKey);
      if (ent == null) throw "Name not found in domain profile.";

      let domainType: IceTypes.ACCOUNT_TYPE = this.appSvc.getCurrentAccountType();
      let name = ent.getdisplayname(domainType != IceTypes.ACCOUNT_TYPE.actProvider && domainType != IceTypes.ACCOUNT_TYPE.actPatient);
      let nameLabel = domainType != IceTypes.ACCOUNT_TYPE.actProvider && domainType != IceTypes.ACCOUNT_TYPE.actPatient ? "Organization: " : "Name of Domain: ";
      if (domainType == IceTypes.ACCOUNT_TYPE.actProvider) {
        this.profileCompanyName = name;
        this.profileContactName = "";
      }
      else {
        this.profileCompanyName = name;
        this.profileContactName = ent.getdisplayname(false);
      }

      if (countryCode != null) {
        this.profileCountryCode = countryCode.code;
      }

      if (currencyCode != null) {
        this.profileCurrencyCode = currencyCode.code;
      }

      if (useTaxonomyCodes) {
        this.taxonomyCodeCtrl = new IcecontrolSettings("icelabel", { linkMode: "labelselect", value: "Taxonomy code: ", placeholder: this.TaxonomyCodeSelect, menuItems: [], width: "75px" },
          null, null, this.controlIDTaxonomyCode)
          .setControlName(this.controlIDTaxonomyCode)
          .createFormControl(taxonomyCode, [Validators.required]);
      }
      controls.push(new IcecontrolSettings("icelabel", { value: "Domain: #" + domain, hasFullWidthContainer: false, class: "" }, null, null, "DomainID"));
      controls.push(new IcecontrolSettings("icelabel", { value: nameLabel + name, hasFullWidthContainer: false, class: "" }, null, null, "Name"));
      if (this.taxonomyCodeCtrl != null) {
        controls.push(this.taxonomyCodeCtrl);
        this.setTaxonomyCodeList([]);
      }

      if (countryCode != null) {
        this.countryCodeCtrl = new IcecontrolSettings("icelabel", { linkMode: "labelselect", value: "Default Country: ", placeholder: this.CountryCodeSelect, menuItems: [], width: "75px" },
          null, null, this.controlIDCountryCode)
          .setControlName(this.controlIDCountryCode)
          .createFormControl(countryCode.code, [Validators.required]);
        controls.push(this.countryCodeCtrl);
        this.setCodeList(countryCode, this.countryCodeCtrl, []);
      }

      if (currencyCode != null) {
        this.currencyCodeCtrl = new IcecontrolSettings("icelabel", { linkMode: "labelselect", value: "Default Currency: ", placeholder: this.CurrencyCodeSelect, menuItems: [], width: "75px" },
          null, null, this.controlIDCurrencyCode)
          .setControlName(this.controlIDCurrencyCode)
          .createFormControl(currencyCode.code, [Validators.required]);
        controls.push(this.currencyCodeCtrl);
        this.setCodeList(currencyCode, this.currencyCodeCtrl, []);
      }
    }
    catch (e) {
      console.log(e);
    }
    return controls;
  }

  viewContact(cons: contact[]): IceResponsiveMattableSettings[] {
    let tables: IceResponsiveMattableSettings[] = [];
    try {
      let access: userTypes.USER_FEATURE_ACCESS = userTypes.USER_FEATURE_ACCESS.ufaNone;
      let ctrlPerm = this.getAppService().getPermission(userTypes.USER_FEATURES.ufSetup);
      if (ctrlPerm)
        access = ctrlPerm.default_access;

      tables.push(
        new IceResponsiveMattableSettings(
          this.tableTagContact,
          [
            new iceColumnDefinition("communication_number_qualifier", "Contact", false, false,
              new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
            new iceColumnDefinition("communication_type", "Type", false, false,
              new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
            new iceColumnDefinition("communication_number", "Details", false, false,
              new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
            new iceColumnDefinition("contact_key", "contact_key", true),
          ],
          this.contactDataSource,
          [],
          false,
          null,
          true,
          ctrlPerm
        ).showAddButton(access == userTypes.USER_FEATURE_ACCESS.ufaAdd || access == userTypes.USER_FEATURE_ACCESS.ufaFullControl)
      );

      if (cons != null) {
        let displayCons = [];
        for (let icon = 0; icon < cons.length; icon++) {
          let typeName = cons[icon]["communication_type"];
          let optList = MedicalcodesService.getContactTypeList().filter(opt => cons[icon]["communication_type"] == opt.value);
          if (optList.length > 0) {
            typeName = optList[0].name;
          }

          let methodName = cons[icon]["communication_number_qualifier"];
          optList = MedicalcodesService.getContactMethodList().filter(opt => cons[icon]["communication_number_qualifier"] == opt.value);
          if (optList.length > 0) {
            methodName = optList[0].name;
          }

          if (this.profilePhone.length == 0 && cons[icon]["communication_number_qualifier"] == "TE")
            this.profilePhone = cons[icon]["communication_number"];

          if (this.profileEmail.length == 0 && cons[icon]["communication_number_qualifier"] == "EM")
            this.profileEmail = cons[icon]["communication_number"];

          let dCon = {
            communication_number_qualifier: methodName,
            communication_type: typeName,
            communication_number: cons[icon]["communication_number"],
            contact_key: cons[icon]["contact_key"],
          };
          displayCons.push(dCon);
        }
        this.contactDataSource.data = displayCons;
      }
    }
    catch (e) {
      console.log(e);
    }
    return tables;
  }

  viewIdentification(ids: identification[], codes: string[]): IceResponsiveMattableSettings[] {
    let tables: IceResponsiveMattableSettings[] = [];
    try {

      let access: userTypes.USER_FEATURE_ACCESS = userTypes.USER_FEATURE_ACCESS.ufaNone;
      let ctrlPerm = this.getAppService().getPermission(userTypes.USER_FEATURES.ufIdentification);
      if (ctrlPerm)
        access = ctrlPerm.default_access;

      this.idTable = new IceResponsiveMattableSettings(
        this.tableTagIdentification,
        [
          new iceColumnDefinition("identification_code_qualifier", "Identification Type", false, false,
            new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
          new iceColumnDefinition("identification_code", "ID", false, false,
            new IcecontrolSettings("icelabel", { placeholder: "Enter ID", width: "100px" }, null, null)),
          new iceColumnDefinition("identification_key", "identification_key", true),
        ],
        this.identificationDataSource,
        [],
        false,
        null,
        true,
        ctrlPerm
      ).showAddButton(access == userTypes.USER_FEATURE_ACCESS.ufaAdd || access == userTypes.USER_FEATURE_ACCESS.ufaFullControl);

      tables.push(this.idTable);

      if (ids != null) {
        let displayIDS = [];
        for (let iid = 0; iid < ids.length; iid++) {
          let dId = {
            identification_code_qualifier: ids[iid]["identification_code_qualifier"],
            identification_code: ids[iid]["identification_code"],
            identification_key: ids[iid]["identification_key"],
          };
          displayIDS.push(dId);
        }
        this.identificationDataSource.data = displayIDS;
      }
    }
    catch (e) {
      console.log(e);
    }
    return tables;
  }

  viewAddress(ads: address[]): IceResponsiveMattableSettings[] {
    let tables: IceResponsiveMattableSettings[] = [];
    try {

      let access: userTypes.USER_FEATURE_ACCESS = userTypes.USER_FEATURE_ACCESS.ufaNone;
      let ctrlPerm = this.getAppService().getPermission(userTypes.USER_FEATURES.ufSetup);
      if (ctrlPerm)
        access = ctrlPerm.default_access;

      tables.push(
        new IceResponsiveMattableSettings(
          this.tableTagAddress,
          [
            new iceColumnDefinition("address_type", "Type", false, false,
              new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
            new iceColumnDefinition("street1", "Address Line 1", false, false,
              new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
            new iceColumnDefinition("street2", "Apt./Unit/Bld.", false, false,
              new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
            new iceColumnDefinition("city", "City", false, false,
              new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
            new iceColumnDefinition("state_id", "State", false, false,
              new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
            new iceColumnDefinition("postal_code", "Postal code", false, false,
              new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
            new iceColumnDefinition("country_id", "Country", false, false,
              new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
            new iceColumnDefinition("address_key", "address_key", true),
          ],
          this.addressDataSource,
          [],
          false,
          null,
          true,
          ctrlPerm
        ).showAddButton(access == userTypes.USER_FEATURE_ACCESS.ufaAdd || access == userTypes.USER_FEATURE_ACCESS.ufaFullControl)
      );

      if (ads != null) {
        let displayAds = [];
        for (let iads = 0; iads < ads.length; iads++) {
          let typeName = ads[iads]["address_type"];
          let optList = MedicalcodesService.getAddressTypeList().filter(opt => ads[iads]["address_type"] == opt.value);
          if (optList.length > 0) {
            typeName = optList[0].name;
          }

          let statName = ads[iads]["state_id"];
          optList = this.appSvc.stateOptions.filter(opt => ads[iads]["state_id"] == opt.value);
          if (optList.length > 0) {
            statName = optList[0].name;
          }

          let countryName = ads[iads]["country_id"];
          optList = this.appSvc.countryOptions.filter(opt => ads[iads]["country_id"] == opt.value);
          if (optList.length > 0) {
            countryName = optList[0].name;
          }

          if (this.profileAddress.length == 0) {
            this.profileAddress = ads[iads]["street1"] + " " + ads[iads]["street2"];
            this.profileCity = ads[iads]["city"];
            this.profileState = statName;
            this.profilePostalCode = ads[iads]["postal_code"];
            this.profileProvince = ads[iads]["province"];
          }

          if (this.profileCountryCode.length == 0)
            this.profileCountryCode = countryName;

          let dAd = {
            address_type: typeName,
            street1: ads[iads]["street1"],
            street2: ads[iads]["street2"],
            city: ads[iads]["city"],
            state_id: statName,
            postal_code: ads[iads]["postal_code"],
            country_id: countryName,
            address_key: ads[iads]["address_key"],
          };
          displayAds.push(dAd);
        }
        this.addressDataSource.data = displayAds;
      }
    }
    catch (e) {
      console.log(e);
    }
    return tables;
  }

  viewSubscription(subs: subscriptionobject[]): IceResponsiveMattableSettings[] {
    let tables: IceResponsiveMattableSettings[] = [];
    try {
      this.subTable = new IceResponsiveMattableSettings(
        this.tableTagSubscription,
        [
          new iceColumnDefinition("title", "Subscription(s)", false, false,
            new IcecontrolSettings("icelabel", { width: "150px" }, null, null)),
          new iceColumnDefinition("features", "Description", false, false,
            new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
          new iceColumnDefinition("summary", "Summary", false, false,
            new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
          new iceColumnDefinition("date", "Date of Payment", false, false,
            new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
          new iceColumnDefinition("rate", "Total", false, false,
            new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
          new iceColumnDefinition("subscription_key", "address_key", true),
        ],
        this.subscriptionDataSource,
        [],
        false,
        null,
        true
      ).showAddButton(true);

      tables.push(this.subTable);
      this.setSubscriptions();
    }
    catch (e) {
      console.log(e);
    }
    return tables;
  }

  viewContactSection(tables: IceResponsiveMattableSettings[], editMode: boolean): IcepanelsectionSettings[] {
    let sections: IcepanelsectionSettings[] = [];
    try {
      let contactGroups: IcepanelgroupSettings[] = [
        new IcepanelgroupSettings(null, tables)
      ];

      sections.push(
        new IcepanelsectionSettings("ContactViewSection", { class: [""], styles: { width: "100%" } }, contactGroups, [], null)
      );

      /// Contact Edit Panel
      this.contactControls = [
        new IcecontrolSettings("iceselect", { menuItems: MedicalcodesService.getContactMethodList(), width: "475px" }, null, {
          onChange: (event) => {
            let commNumberCtrl = this.contactControls.find(c => c.controlName === "communication_number");

            switch (event.value) {
              case "EM":
                commNumberCtrl.properties = { ...commNumberCtrl.properties, inputType: "email" };
                commNumberCtrl.getFormControl().clearValidators();
                break;
              case "FX":
                commNumberCtrl.properties = { ...commNumberCtrl.properties, inputType: "number" };
                commNumberCtrl.getFormControl().clearValidators();
                break;
              case "TE":
                commNumberCtrl.properties = { ...commNumberCtrl.properties, inputType: "number" };
                commNumberCtrl.getFormControl().setValidators([Validators.minLength(10), Validators.maxLength(10)]);
                break;
            }
            commNumberCtrl.getFormControl().updateValueAndValidity();
          }
        }, "communication_number_qualifier", "Select Method")
          .setControlName("communication_number_qualifier")
          .createFormControl("", [Validators.required])
          .setOptions(MedicalcodesService.getContactMethodList()),

        new IcecontrolSettings("iceselect", { menuItems: MedicalcodesService.getContactTypeList(), width: "475px" }, null, null, "communication_type", "Select Type")
          .setControlName("communication_type")
          .createFormControl(0, [Validators.required])
          .setOptions(MedicalcodesService.getContactTypeList()),

        new IcecontrolSettings("iceinput", { width: "475px", inputType: 'number' }, null, null, "communication_number", "Enter contact information")
          .setControlName("communication_number")
          .createFormControl("", [Validators.required, Validators.minLength(10), Validators.maxLength(10)]),
      ];

      sections.push(this.appSvc.viewEditPanelSection(this.sectionTagEditContact, this.contactControls));
    }
    catch (e) {
      console.log(e);
    }
    return sections;
  }

  viewAddressSection(tables: IceResponsiveMattableSettings[], editMode: boolean): IcepanelsectionSettings[] {
    let sections: IcepanelsectionSettings[] = [];
    try {
      let addressGroups: IcepanelgroupSettings[] = [
        new IcepanelgroupSettings(null, tables)
      ];

      sections.push(
        new IcepanelsectionSettings("AddressViewSection", { class: ["yalla"], styles: { width: "100%" } }, addressGroups, [], null)
      );

      /// Address Edit Panel
      let adrStateCtrl = new IcecontrolSettings("iceselect", { menuItems: [], width: "475px" }, null, null, "state_id", "Enter State")
        .setControlName("state_id")
        .createFormControl("", [Validators.required]);

      let adrCountryCtrl = new IcecontrolSettings("iceselect", { menuItems: [], width: "475px" }, null, null, "country_id", "Enter Country")
        .setControlName("country_id")
        .createFormControl("", [Validators.required]);

      let adrControls = [
        new IcecontrolSettings("iceselect", { menuItems: MedicalcodesService.getAddressTypeList(), width: "475px" }, null, null, "address_type", "Select Type")
          .setControlName("address_type")
          .createFormControl(0, [Validators.required])
          .setOptions(MedicalcodesService.getAddressTypeList()),

        new IcecontrolSettings("iceinput", { width: "475px" }, null, null, "street1", "Enter Street 1")
          .setControlName("street1")
          .createFormControl("", [Validators.required]),

        new IcecontrolSettings("iceinput", { width: "475px" }, null, null, "street2", "Enter Street 1")
          .setControlName("street2")
          .createFormControl("", [Validators.required]),

        new IcecontrolSettings("iceinput", { width: "475px" }, null, null, "city", "Enter City")
          .setControlName("city")
          .createFormControl("", [Validators.required]),

        adrStateCtrl,

        new IcecontrolSettings("iceinput", { width: "475px" }, null, null, "postal_code", "Enter Postal Code")
          .setControlName("postal_code")
          .createFormControl("", [Validators.required]),

        adrCountryCtrl,
      ];

      sections.push(this.appSvc.viewEditPanelSection(this.sectionTagEditAddress, adrControls));

      this.appSvc.setStateIDList(this.medCodeSvc, adrStateCtrl, this.profileCountryCode, this.addressDataSource);
      this.appSvc.setCountryCodeList(this.medCodeSvc, adrCountryCtrl, this.addressDataSource);
    }
    catch (e) {
      console.log(e);
    }
    return sections;
  }

  viewIdentificationSection(tables: IceResponsiveMattableSettings[], idCodeList: string[], editMode: boolean): IcepanelsectionSettings[] {
    let sections: IcepanelsectionSettings[] = [];
    try {
      let idGroups: IcepanelgroupSettings[] = [
        new IcepanelgroupSettings(null, tables)
      ];

      sections.push(
        new IcepanelsectionSettings("IdentificationViewSection", { class: ["yalla"], styles: { width: "100%" } }, idGroups, [], null)
      );

      /// Identification Edit Panel
      let idCodeCtrl = new IcecontrolSettings("iceselect", { menuItems: [], width: "475px" }, null, {
        onChange: (event) => {
          let identificationCodeCtrl = this.idControls.find(c => c.controlName === "identification_code");

          switch (event.value) {
            case "XX":
              identificationCodeCtrl.getFormControl().setValidators([Validators.minLength(10), Validators.maxLength(10)]);
              break;
            default:
              identificationCodeCtrl.getFormControl().clearValidators();
          }
          identificationCodeCtrl.getFormControl().updateValueAndValidity();
        }
      }, "identification_code_qualifier", "Select Type")
        .setControlName("identification_code_qualifier")
        .createFormControl("", [Validators.required]);

      this.idControls = [
        idCodeCtrl,

        new IcecontrolSettings("iceinput", { width: "475px" }, null, null, "identification_code", "Enter ID")
          .setControlName("identification_code")
          .createFormControl("", [Validators.required]),
      ];

      sections.push(this.appSvc.viewEditPanelSection(this.sectionTagEditIdentification, this.idControls));

      this.setIDCodeList(idCodeCtrl, idCodeList);
    }
    catch (e) {
      console.log(e);
    }
    return sections;
  }

  viewSureScriptsIdentificationSection(editMode: boolean): IcepanelsectionSettings {
    let section: IcepanelsectionSettings = null;
    try {
      let controls = [];
      this.surescriptsIDControls["ActiveStartTime"] = new IcecontrolSettings("icedatepicker", { width: "150px" }, null, null, "ActiveStartTime", "Enter SPI Active Start Date")
        .setControlName("ActiveStartTime")
        .createFormControl("", [Validators.required]);
      controls.push(this.surescriptsIDControls["ActiveStartTime"]);

      this.surescriptsIDControls["ActiveEndTime"] = new IcecontrolSettings("icedatepicker", { width: "150px" }, null, null, "ActiveEndTime", "Enter SPI Active End Date")
        .setControlName("ActiveEndTime")
        .createFormControl("", [Validators.required]);
      controls.push(this.surescriptsIDControls["ActiveEndTime"]);

      this.surescriptsIDControls["UpdateDisable"] = new IcecontrolSettings("iceslidetoggle",
        { placeholder: "Upload Action: ", onDisplayValue: this.providerUpdateDisplayValue, offDisplayValue: this.providerDisableDisplayValue, width: "100px" },
        null, null, "UpdateDisable")
        .setControlName("UpdateDisable")
        .createFormControl(false, [Validators.required]);
      controls.push(this.surescriptsIDControls["UpdateDisable"]);

      this.surescriptsIDControls["ServiceLevel"] = new IcecontrolSettings("iceautocomplete", { menuItems: [], width: "450px" }, null, null, "ServiceLevel", "Enter Service Level (i.e. New Rx)")
        .setControlName("ServiceLevel")
        .createFormControl([], [Validators.required])
        .setMultipleSelection(true);
      controls.push(this.surescriptsIDControls["ServiceLevel"]);

      let svcLvlOpts = this.surescriptsIDControls["ServiceLevel"].getOptions();
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelNew), value: IceTypes.ServiceLevel.svcLevelNew });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelRefill), value: IceTypes.ServiceLevel.svcLevelRefill });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelChange), value: IceTypes.ServiceLevel.svcLevelChange });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelRxFill), value: IceTypes.ServiceLevel.svcLevelRxFill });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelCancel), value: IceTypes.ServiceLevel.svcLevelCancel });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelMedHistory), value: IceTypes.ServiceLevel.svcLevelMedHistory });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelReSupp), value: IceTypes.ServiceLevel.svcLevelReSupp });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelCensus), value: IceTypes.ServiceLevel.svcLevelCensus });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelCCR), value: IceTypes.ServiceLevel.svcLevelCCR });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelControlledSubstance), value: IceTypes.ServiceLevel.svcLevelControlledSubstance });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelCIMessage), value: IceTypes.ServiceLevel.svcLevelCIMessage });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelCIEvent), value: IceTypes.ServiceLevel.svcLevelCIEvent });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelePA), value: IceTypes.ServiceLevel.svcLevelePA });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelLongTermCare), value: IceTypes.ServiceLevel.svcLevelLongTermCare });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelRxFillIndicatorChange), value: IceTypes.ServiceLevel.svcLevelRxFillIndicatorChange });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelDrugAdministration), value: IceTypes.ServiceLevel.svcLevelDrugAdministration });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelNewRxRequest), value: IceTypes.ServiceLevel.svcLevelNewRxRequest });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelNewRxResponseDenied), value: IceTypes.ServiceLevel.svcLevelNewRxResponseDenied });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelRecertification), value: IceTypes.ServiceLevel.svcLevelRecertification });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelPatMedBenefitCheck), value: IceTypes.ServiceLevel.svcLevelPatMedBenefitCheck });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelSpecialty), value: IceTypes.ServiceLevel.svcLevelSpecialty });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelRxTransfer), value: IceTypes.ServiceLevel.svcLevelRxTransfer });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelSPOAutoEnrollment), value: IceTypes.ServiceLevel.svcLevelSPOAutoEnrollment });

      section = new IcepanelsectionSettings("SurescriptsViewSection", { class: ["yalla"], styles: { width: "100%" } }, [], controls, null);
    }
    catch (e) {
      console.log(e);
    }
    return section;
  }

  viewSubscriptionSection(tables: IceResponsiveMattableSettings[], countries: basecode[], currencies: basecode[], editMode: boolean): IcepanelsectionSettings[] {
    let sections: IcepanelsectionSettings[] = [];
    try {
      let subscriptionGroups: IcepanelgroupSettings[] = [
        new IcepanelgroupSettings(null, tables)
      ];

      sections.push(
        new IcepanelsectionSettings("SubscriptionViewSection", { class: [""], styles: { width: "100%" } }, subscriptionGroups, [], null)
      );

      /// Subscription Payment Panel
      let subPaymentCtrl = new IcecontrolSettings("icesubscriptionpayment", {
        menuItems: [],
        width: "475px",
        subTotal: 0.0,
        otherFees: 0.0,
        grandTotal: 0.0,
        lastErrors: null,
        defaultCountry: "",
        defaultCurrency: ""
      }, null, null, "paymentstatus")
        .setControlName("paymentstatus")
        .createFormControl({}, [Validators.required]);

      subPaymentCtrl.createChangeControlEvent().subscribe(
        event => {
          this.onControlChange(event);
        },
        error => { }
      );

      subPaymentCtrl.createClickControlEvent().subscribe(
        event => {
          this.onDefaultButtonClick(event, [], [], null);
        },
        error => { }
      );

      let subPaymentControls = [
        subPaymentCtrl,
      ];

      sections.push(this.appSvc.viewEditPanelSection(this.sectionTagSubscriptionPayment, subPaymentControls, false));

      let country = "US";
      if (countries.length > 0)
        country = countries[0].code;

      /// Subscription Payment Panel
      let paymentReceiptCtrl = new IcecontrolSettings("icepaymentreceipt", {
        menuItems: [],
        width: "475px",
        companyName: "ICEMEDX, Inc.",
        companyCountry: country, // make the company's country the same as customer
        companyPhone: "",
        orderInformation: null,
      }, null, null, "paymentreceipt")
        .setControlName("paymentreceipt")
        .createFormControl({}, []);

      let paymentReceiptControls = [
        paymentReceiptCtrl,
      ];

      sections.push(this.appSvc.viewEditPanelSection(this.sectionTagPaymentReceipt, paymentReceiptControls, false));

      this.setLicenseList(subPaymentCtrl, countries, currencies, []);
    }
    catch (e) {
      console.log(e);
    }
    return sections;
  }

  viewOutboundNetworkConnections(params: connectionparameters[], typerefs: transtypereference[]): IceResponsiveMattableSettings[] {
    let tables: IceResponsiveMattableSettings[] = [];
    try {
      this.outboundTable = new IceResponsiveMattableSettings(
        this.tableTagOutboundNetworkConnectionTable,
        [
          new iceColumnDefinition("connection_title", "Outbound Connection To", false, false,
            new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
          new iceColumnDefinition("application", "Application", false, false,
            new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
          new iceColumnDefinition("application_code", "App. Code", false, false,
            new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
          new iceColumnDefinition("server_user_name", "Username (or App. Key)", false, false,
            new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
          new iceColumnDefinition("server_password", "Password (or Secret)", false, false,
            new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
          new iceColumnDefinition("test_required", "Test Required", false, false,
            new IcecontrolSettings("icelabel", { onDisplayValue: "Yes", offDisplayValue: "No", width: "100px" }, null, null)),
          new iceColumnDefinition("server_connection_parameters_key", "server_connection_parameters_key", false, true),
          new iceColumnDefinition("trans_type_code", "trans_type_code", false, true),
          new iceColumnDefinition("account_type", "account_type", false, true),
          new iceColumnDefinition("trans_account", "trans_account", false, true),
          new iceColumnDefinition("connection_parameters_key", "connection_parameters_key", true),
          new iceColumnDefinition("QuickActions", "", false, false),
        ],
        this.outboundParamsDataSource,
        [IceTypes.recordQuickActionRemove],
        false,
        null,
        true
      );

      tables.push(this.outboundTable);

      if (params != null) {
        let displayParams = [];
        for (let iparam = 0; iparam < params.length; iparam++) {

          let transtypecode = IceTypes.TRANSTYPE.itNone;
          let serverconnparameterskey = "";
          let testrequired = false;

          let trefs = typerefs.filter(x => x.connection_parameters_key == params[iparam]["connection_parameters_key"]);
          if (trefs.length > 0) {
            transtypecode = Iceutility.toLong(trefs[0].trans_type_code);
            serverconnparameterskey = trefs[0].server_connection_parameters_key;
            testrequired = trefs[0].test_required;
          }

          if (transtypecode == IceTypes.TRANSTYPE.itePrescriptionRouting) {
            this.providerHIEUpdateDisable = true;
          }

          let dCon = {
            connection_title: params[iparam]["connection_title"],
            trans_account: params[iparam]["trans_account"],
            application: MessageService.getTransTypeDesc(transtypecode),
            account_type: params[iparam]["account_type"],
            trans_type_code: transtypecode,
            application_code: params[iparam]["application_code"],
            server_user_name: typeof params[iparam]["server_user_name"] === "undefined" ? "" : params[iparam]["server_user_name"],
            server_password: params[iparam]["server_password"],
            test_required: Iceutility.toBoolean(testrequired),
            server_connection_parameters_key: serverconnparameterskey,
            connection_parameters_key: params[iparam]["connection_parameters_key"],
          };
          displayParams.push(dCon);
        }
        this.outboundParamsDataSource.data = displayParams;
      }
    }
    catch (e) {
      console.log(e);
    }
    return tables;
  }

  viewInboundNetworkConnections(params: connectionparameters[], ttypes: transtype[]): IceResponsiveMattableSettings[] {
    let tables: IceResponsiveMattableSettings[] = [];
    try {
      let access: userTypes.USER_FEATURE_ACCESS = userTypes.USER_FEATURE_ACCESS.ufaNone;
      let ctrlPerm = this.getAppService().getPermission(userTypes.USER_FEATURES.ufX12NSearch);
      if (ctrlPerm)
        access = ctrlPerm.default_access;

      this.inboundTable = new IceResponsiveMattableSettings(
        this.tableTagInboundNetworkConnectionTable,
        [
          new iceColumnDefinition("connection_title", "Inbound Connection To", false, false,
            new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
          new iceColumnDefinition("application", "Application", false, false,
            new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
          new iceColumnDefinition("disabled", "Status", false, false,
            new IcecontrolSettings("icelabel", { onDisplayValue: "Disabled", offDisplayValue: "Enabled", width: "100px" }, null, null)),
          new iceColumnDefinition("participating_type", "Participating", false, false,
            new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
          new iceColumnDefinition("underdevelopment", "Test Mode", false, false,
            new IcecontrolSettings("icelabel", { onDisplayValue: "Yes", offDisplayValue: "No", width: "100px" }, null, null)),
          new iceColumnDefinition("contract_required", "Contract Required", false, false,
            new IcecontrolSettings("icelabel", { onDisplayValue: "Yes", offDisplayValue: "No", width: "100px" }, null, null)),
          new iceColumnDefinition("must_contact", "Must Contact", false, false,
            new IcecontrolSettings("icelabel", { onDisplayValue: "Yes", offDisplayValue: "No", width: "100px" }, null, null)),
          new iceColumnDefinition("test_required", "Test Required", false, false,
            new IcecontrolSettings("icelabel", { onDisplayValue: "Yes", offDisplayValue: "No", width: "100px" }, null, null)),
          new iceColumnDefinition("application_code", "App. Code", false, false,
            new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
          new iceColumnDefinition("server_user_name", "Username (or App. Key)", false, false,
            new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
          new iceColumnDefinition("server_password", "Password (or Secret)", false, false,
            new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
          new iceColumnDefinition("ip", "Server Address", false, false,
            new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
          new iceColumnDefinition("folder", "Server Folder", false, false,
            new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
          new iceColumnDefinition("root_name", "Server App. (or Params.)", false, false,
            new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
          new iceColumnDefinition("transport_format", "Data Format", false, false,
            new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
          new iceColumnDefinition("connection_type", "Conn. Type", false, false,
            new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
          new iceColumnDefinition("protocol_type", "Protocol", false, false,
            new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
          new iceColumnDefinition("protocol_version", "Protocol Version", false, false,
            new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
          new iceColumnDefinition("protocol_api", "Protocol API", false, false,
            new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
          new iceColumnDefinition("protocol_api_version", "API Version", false, false,
            new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
          new iceColumnDefinition("trans_type_code", "trans_type_code", false, true),
          new iceColumnDefinition("account_type", "account_type", false, true),
          new iceColumnDefinition("trans_account", "trans_account", false, true),
          new iceColumnDefinition("connection_parameters_key", "connection_parameters_key", true),
        ],
        this.inboundParamsDataSource,
        [],
        false,
        null,
        true,
        ctrlPerm
      ).showAddButton(access == userTypes.USER_FEATURE_ACCESS.ufaAdd || access == userTypes.USER_FEATURE_ACCESS.ufaFullControl);

      tables.push(this.inboundTable);

      if (params != null) {
        let displayParams = [];
        for (let iparam = 0; iparam < params.length; iparam++) {

          let transtypecode = IceTypes.TRANSTYPE.itNone;
          let testrequired = false;
          let disabled = false;
          let underdevelopment = false;
          let participating_type = IceTypes.participation_type.pptNonParticipating;
          let contract_required = false;
          let must_contact = false;
          let transport_format = IceTypes.DATA_TRANSPORT_FORMAT.datatfmtNone;
          let connection_type = IceTypes.CONNECTIONTYPE.conntypNone;
          let protocol_type = IceTypes.PROTOCOL.protocolNone;
          let protocol_version = "";
          let protocol_api = IceTypes.PROTOCOLAPI.papiURL;
          let protocol_api_version = "";

          let found_ttypes = ttypes.filter(x => x.connection_parameters_key == params[iparam]["connection_parameters_key"]);
          if (found_ttypes.length > 0) {
            transtypecode = found_ttypes[0].trans_type_code;
            testrequired = found_ttypes[0].test_required;
            disabled = found_ttypes[0].disabled;
            underdevelopment = found_ttypes[0].underdevelopment;
            participating_type = <IceTypes.participation_type>found_ttypes[0].participating_type;
            contract_required = found_ttypes[0].contract_required;
            must_contact = found_ttypes[0].must_contact;
            transport_format = <IceTypes.DATA_TRANSPORT_FORMAT>found_ttypes[0].transport_format;
            connection_type = <IceTypes.CONNECTIONTYPE>found_ttypes[0].connection_type;
            protocol_type = <IceTypes.PROTOCOL>found_ttypes[0].protocol_type;
            protocol_version = found_ttypes[0].protocol_version;
            protocol_api = <IceTypes.PROTOCOLAPI>found_ttypes[0].protocol_api;
            protocol_api_version = found_ttypes[0].protocol_api_version;
          }

          let dCon = {
            connection_title: params[iparam]["connection_title"],
            trans_account: params[iparam]["trans_account"],
            application: MessageService.getTransTypeDesc(transtypecode),
            disabled: Iceutility.toBoolean(disabled), 
            account_type: params[iparam]["account_type"],
            trans_type_code: transtypecode,
            application_code: params[iparam]["application_code"],
            server_user_name: params[iparam]["server_user_name"],
            server_password: params[iparam]["server_password"],
            test_required: Iceutility.toBoolean(testrequired),
            underdevelopment: Iceutility.toBoolean(underdevelopment),
            participating_type: MessageService.getParticipatingTypeDesc(participating_type),
            contract_required: Iceutility.toBoolean(contract_required),
            must_contact: Iceutility.toBoolean(must_contact),
            ip: params[iparam]["ip"],
            folder: params[iparam]["folder"],
            root_name: params[iparam]["root_name"],
            transport_format: MessageService.getDataTransportFormatDesc(transport_format),
            connection_type: MessageService.getConnectionTypeDesc(connection_type),
            protocol_type: MessageService.getProtocolDesc(protocol_type),
            protocol_version: protocol_version,
            protocol_api: MessageService.getProtocolAPIDesc(protocol_api),
            protocol_api_version: protocol_api_version,
            connection_parameters_key: params[iparam]["connection_parameters_key"],
          };
          displayParams.push(dCon);
        }
        this.inboundParamsDataSource.data = displayParams;
      }
    }
    catch (e) {
      console.log(e);
    }
    return tables;
  }

  viewNewOutboundNetworkConnections(): IcepanelsectionSettings[] {
    let connections: IcepanelsectionSettings[] = [];

    try {
      this.newOutboundDomainTypeCtrl = new IcecontrolSettings("iceselect", { menuItems: DomainService.getDomainTypes(), width: "450px" }, null, null, this.controlIDNewOutboundTypeofDomain, "New Outbound Type of Connection")
        .setControlName(this.controlIDNewOutboundTypeofDomain)
        .createFormControl(0, [Validators.required]);

      this.newOutboundDomainTypeCtrl.createChangeControlEvent().subscribe(
        event => {
          this.onControlChange(event);
        },
        error => {}
      );

      this.newOutboundDomainNameCtrl = new IcecontrolSettings("iceautocomplete", { menuItems: [], width: "450px" }, null, null, this.controlIDNewOutboundNameofDomain, "Enter Name of Network Domain to Connect to")
        .setControlName(this.controlIDNewOutboundNameofDomain)
        .createFormControl("", [Validators.required]);

      this.newOutboundDomainNameCtrl.createChangeControlEvent().subscribe(
        event => {
          this.onControlChange(event);
        },
        error => { }
      );

      // This DDL should come from the receiver's application list after recevier is selected
      this.newOutboundDomainApplicaionCtrl = new IcecontrolSettings("iceselect", { menuItems: [], width: "450px" }, null, null, this.controlIDNewOutboundAppofDomain, "Application")
        .setControlName(this.controlIDNewOutboundAppofDomain)
        .createFormControl("", [Validators.required]);

      this.newOutboundDomainSection = new IcepanelsectionSettings(
        "NewOutboundDomainSection", { class: [], styles: { width: "100%" } }, [], [
        this.newOutboundDomainTypeCtrl,
      ], null).setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical).setShow(true);

      this.newOutboundDomainSubmitSection = new IcepanelsectionSettings(
        "NewOutboundDomainButtonSection", { class: [], styles: { width: "100%" } }, [], [
          this.newOutboundDomainNameCtrl,
          this.newOutboundDomainApplicaionCtrl,
          new IcecontrolSettings("icepanelbutton", { text: "Add Connection", class: [], glyphClass: "fa-plus" }, null, null, this.controlIDAddNewOutboundConnection),
          new IcecontrolSettings("icepanelbutton", { text: "Cancel", class: [], glyphClass: "fa-times" }, null, null, this.controlIDAddNewOutboundConnectionCancel)
      ], null).setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignHorizontal).setShow(false);

      connections.push(this.newOutboundDomainSection);
      connections.push(this.newOutboundDomainSubmitSection);

      let ctrlPerm = this.getAppService().getPermission(userTypes.USER_FEATURES.ufX12NSearch);
      if (ctrlPerm && (ctrlPerm.default_access == userTypes.USER_FEATURE_ACCESS.ufaNone
        || ctrlPerm.default_access == userTypes.USER_FEATURE_ACCESS.ufaRemove)) {
        this.newOutboundDomainTypeCtrl.setDisabled(true);
        this.newOutboundDomainTypeCtrl.setReadonly(true);
      }
    }
    catch (e) {
      console.log(e);
    }
    return connections;
  }

  viewEditOutboundNetworkConnections(): IcepanelsectionSettings[] {
    let connections: IcepanelsectionSettings[] = [];

    try {
      this.editOutboundTitleCtrl = new IcecontrolSettings("icelabel", { width: "300px" }, null, null, this.controlIDEditOutboundTitle, "Title")
        .setControlName(this.controlIDEditOutboundTitle)
        .createFormControl("", [Validators.required]);

      this.editOutboundApplicationCtrl = new IcecontrolSettings("icelabel", { width: "300px" }, null, null, this.controlIDEditOutboundApplication, "Application")
        .setControlName(this.controlIDEditOutboundApplication)
        .createFormControl("", [Validators.required]);

      this.editOutboundCodeCtrl = new IcecontrolSettings("iceinput", { width: "300px" }, null, null, this.controlIDEditOutboundCode, "Enter Code")
        .setControlName(this.controlIDEditOutboundCode)
        .createFormControl("", [Validators.required]);

      this.editOutboundUsernameCtrl = new IcecontrolSettings("iceinput", { width: "300px" }, null, null, this.controlIDEditOutboundUsername, "Enter Username or Key")
        .setControlName(this.controlIDEditOutboundUsername)
        .createFormControl("", [Validators.required]);

      this.editOutboundPasswordCtrl = new IcecontrolSettings("iceinput", { width: "300px" }, null, null, this.controlIDEditOutboundPassword, "Enter Password")
        .setControlName(this.controlIDEditOutboundPassword)
        .createFormControl("", [Validators.required]);

      this.editOutboundDomainSubmitSection = new IcepanelsectionSettings(
        "NewOutboundDomainButtonSection", { class: [], styles: { width: "100%" } }, [], [
        this.editOutboundTitleCtrl,
        this.editOutboundApplicationCtrl,
        this.editOutboundCodeCtrl,
        this.editOutboundUsernameCtrl,
        this.editOutboundPasswordCtrl,
        new IcecontrolSettings("icepanelbutton", { text: "Save Connection", class: [], glyphClass: "fa-plus" }, null, null, this.controlIDEditOutboundConnectionSave),
        new IcecontrolSettings("icepanelbutton", { text: "Cancel", class: [], glyphClass: "fa-times" }, null, null, this.controlIDEditOutboundConnectionCancel)
      ], null).setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignHorizontal).setShow(false);

      connections.push(this.editOutboundDomainSubmitSection);
    }
    catch (e) {
      console.log(e);
    }
    return connections;
  }

  viewEditInboundNetworkConnections(): IcepanelsectionSettings[] {
    let connections: IcepanelsectionSettings[] = [];

    try {
      this.editInboundConnectionTitleCtrl = new IcecontrolSettings("iceinput", { menuItems: [], width: "300px" }, null, null, this.controlIDEditInboundConnectionTitle, "Enter Connection Title")
        .setControlName(this.controlIDEditInboundConnectionTitle)
        .createFormControl("", [Validators.required]);

      this.editInboundDomainApplicaionCtrl = new IcecontrolSettings("iceselect", { menuItems: MessageService.getTransTypes(), width: "300px" }, null, null, this.controlIDEditInboundAppofDomain, "Application")
        .setControlName(this.controlIDEditInboundAppofDomain)
        .createFormControl(0, [Validators.required]);

      this.editInboundCodeCtrl = new IcecontrolSettings("iceinput", { menuItems: [], width: "300px" }, null, null, this.controlIDEditInboundCode, "Enter Code")
        .setControlName(this.controlIDEditInboundCode)
        .createFormControl("", [Validators.required]);

      this.editInboundUsernameCtrl = new IcecontrolSettings("iceinput", { menuItems: [], width: "300px" }, null, null, this.controlIDEditInboundUsername, "Enter Username or Key")
        .setControlName(this.controlIDEditInboundUsername)
        .createFormControl("", [Validators.required]);

      this.editInboundPasswordCtrl = new IcecontrolSettings("iceinput", { menuItems: [], width: "300px" }, null, null, this.controlIDEditInboundPassword, "Enter Password")
        .setControlName(this.controlIDEditInboundPassword)
        .createFormControl("", [Validators.required]);

      this.editInboundStatusCtrl = new IcecontrolSettings("iceslidetoggle", { placeholder: "Status", onDisplayValue: "Disabled", offDisplayValue: "Enabled", width: "100px" }, null, null, this.controlIDEditInboundStatus, "Status")
        .setControlName(this.controlIDEditInboundStatus)
        .createFormControl(false, [Validators.required]);

      this.editInboundParticipatingCtrl = new IcecontrolSettings("iceselect", { menuItems: MessageService.getParticipatingTypes(), width: "300px" }, null, null, this.controlIDEditInboundParticipating, "Participating")
        .setControlName(this.controlIDEditInboundParticipating)
        .createFormControl(0, [Validators.required]);

      this.editInboundTestModeCtrl = new IcecontrolSettings("iceslidetoggle", { placeholder: "Test Mode", onDisplayValue: "Yes", offDisplayValue: "No", width: "100px" }, null, null, this.controlIDEditInboundTestMode, "Participating")
        .setControlName(this.controlIDEditInboundTestMode)
        .createFormControl(false, [Validators.required]);

      this.editInboundContactRequiredCtrl = new IcecontrolSettings("iceslidetoggle", { placeholder: "Contract Required", onDisplayValue: "Yes", offDisplayValue: "No", width: "100px" }, null, null, this.controlIDEditInboundContactRequired, "Contact Required")
        .setControlName(this.controlIDEditInboundContactRequired)
        .createFormControl(false, [Validators.required]);

      this.editInboundMustContactCtrl = new IcecontrolSettings("iceslidetoggle", { placeholder: "Must Contact", onDisplayValue: "Yes", offDisplayValue: "No", width: "100px" }, null, null, this.controlIDEditInboundMustContact, "Must Contact")
        .setControlName(this.controlIDEditInboundMustContact)
        .createFormControl(false, [Validators.required]);

      this.editInboundTestRequiredCtrl = new IcecontrolSettings("iceslidetoggle", { placeholder: "Test Required", onDisplayValue: "Yes", offDisplayValue: "No", width: "100px" }, null, null, this.controlIDEditInboundTestRequired, "Test Required")
        .setControlName(this.controlIDEditInboundTestRequired)
        .createFormControl(false, [Validators.required]);

      this.editInboundServerCtrl = new IcecontrolSettings("iceinput", { placeholder: "Enter Server Address", width: "300px" }, null, null, this.controlIDEditInboundServer, "Enter Server Address")
        .setControlName(this.controlIDEditInboundServer)
        .createFormControl("", [Validators.required]);

      this.editInboundFolderCtrl = new IcecontrolSettings("iceinput", { placeholder: "Enter Folder", width: "300px" }, null, null, this.controlIDEditInboundFolder, "Enter Folder")
        .setControlName(this.controlIDEditInboundFolder)
        .createFormControl("", [Validators.required]);

      this.editInboundAppParamCtrl = new IcecontrolSettings("iceinput", { placeholder: "Enter App.", width: "300px" }, null, null, this.controlIDEditInboundAppParam, "Enter App.")
        .setControlName(this.controlIDEditInboundAppParam)
        .createFormControl("", [Validators.required]);

      this.editInboundDataFormatCtrl = new IcecontrolSettings("iceselect", { menuItems: MessageService.getDataTransportFormats(), width: "300px" }, null, null, this.controlIDEditInboundDataFormat, "Select Format")
        .setControlName(this.controlIDEditInboundDataFormat)
        .createFormControl(0, [Validators.required]);

      this.editInboundConnectionTypeCtrl = new IcecontrolSettings("iceselect", { menuItems: MessageService.getConnectionTypes(), width: "300px" }, null, null, this.controlIDEditInboundConnectionType, "Select Conn. Type")
        .setControlName(this.controlIDEditInboundConnectionType)
        .createFormControl(0, [Validators.required]);

      this.editInboundProtocolCtrl = new IcecontrolSettings("iceselect", { menuItems: MessageService.getProtocols(), width: "300px" }, null, null, this.controlIDEditInboundProtocol, "Select Protocol")
        .setControlName(this.controlIDEditInboundProtocol)
        .createFormControl(0, [Validators.required]);

      this.editInboundProtocolVersionCtrl = new IcecontrolSettings("iceinput", { placeholder: "Enter Protocol version", width: "300px" }, null, null, this.controlIDEditInboundProtocolVersion, "Enter Protocol version")
        .setControlName(this.controlIDEditInboundProtocolVersion)
        .createFormControl("", [Validators.required]);

      this.editInboundProtocolAPICtrl = new IcecontrolSettings("iceselect", { menuItems: MessageService.getProtocolAPIs(), width: "300px" }, null, null, this.controlIDEditInboundProtocolAPI, "Select Protocol API")
        .setControlName(this.controlIDEditInboundProtocolAPI)
        .createFormControl(0, [Validators.required]);

      this.editInboundProtocolAPIVersionCtrl = new IcecontrolSettings("iceinput", { placeholder: "Enter API version", width: "300px" }, null, null, this.controlIDEditInboundProtocolAPIVersion, "Enter API version")
        .setControlName(this.controlIDEditInboundProtocolAPIVersion)
        .createFormControl("", [Validators.required]);

      this.editInboundDomainSubmitSection = new IcepanelsectionSettings(
        "NewInboundDomainButtonSection", { class: [], styles: { width: "100%" } }, [], [
        this.editInboundConnectionTitleCtrl,
        this.editInboundDomainApplicaionCtrl,
        this.editInboundStatusCtrl,
        this.editInboundParticipatingCtrl,
        this.editInboundTestModeCtrl,
        this.editInboundContactRequiredCtrl,
        this.editInboundMustContactCtrl,
        this.editInboundTestRequiredCtrl,
        this.editInboundCodeCtrl,
        this.editInboundUsernameCtrl,
        this.editInboundPasswordCtrl,
        this.editInboundServerCtrl,
        this.editInboundFolderCtrl,
        this.editInboundAppParamCtrl,
        this.editInboundDataFormatCtrl,
        this.editInboundConnectionTypeCtrl,
        this.editInboundProtocolCtrl,
        this.editInboundProtocolVersionCtrl,
        this.editInboundProtocolAPICtrl,
        this.editInboundProtocolAPIVersionCtrl,
        new IcecontrolSettings("icepanelbutton", { text: "Save Connection", class: [], glyphClass: "fa-plus" }, null, null, this.controlIDEditInboundConnectionSave),
        new IcecontrolSettings("icepanelbutton", { text: "Cancel", class: [], glyphClass: "fa-times" }, null, null, this.controlIDEditInboundConnectionCancel)
      ], null).setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignHorizontal).setShow(false);

      connections.push(this.editInboundDomainSubmitSection);
    }
    catch (e) {
      console.log(e);
    }
    return connections;
  }

  viewNetworkInformation(dom: IceEntity, svclevels: number[]): IceResponsiveMattableSettings[] {
    if (dom == null) return [];

    let tables: IceResponsiveMattableSettings[] = [];
    try {
      let access: userTypes.USER_FEATURE_ACCESS = userTypes.USER_FEATURE_ACCESS.ufaNone;
      let ctrlPerm = this.getAppService().getPermission(userTypes.USER_FEATURES.ufSetup);
      if (ctrlPerm)
        access = ctrlPerm.default_access;

      tables.push(
        new IceResponsiveMattableSettings(
          this.tableTagNetworkInformation,
          [
            new iceColumnDefinition("infoField", "Network Information for " + this.profileCompanyName, false, false,
              new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
            new iceColumnDefinition("infoData", "Value", false, false,
              new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
            new iceColumnDefinition("infoKey", "", true),
          ],
          this.networkInfoDataSource,
          [],
          false,
          null,
          true,
          ctrlPerm
        )
      );

      let displayInfo = [];
      if (dom["activestarttime"] != null)
        displayInfo.push({ infoField: "Active Start Time", infoData: Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(dom["activestarttime"])), infoKey: "activestarttime" });

      if (dom["activeendtime"] != null)
        displayInfo.push({ infoField: "Active End Time", infoData: Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(dom["activeendtime"])), infoKey: "activeendtime" });

      if (dom["lastmodifieddate"] != null)
        displayInfo.push({ infoField: "Last Network Modification", infoData: Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(dom["lastmodifieddate"])), infoKey: "lastmodifieddate" });

      let lvlDesc = [];
      if (svclevels != null) {
        for (let ilvl = 0; ilvl < svclevels.length; ilvl++) {
          lvlDesc.push(OrderService.getServiceLevel(<IceTypes.ServiceLevel>Iceutility.toLong(svclevels[ilvl]["service_level"])));
        }
      }
      displayInfo.push({ infoField: "Service Level(s)", infoData: lvlDesc.join(", "), infoKey: "serviceLevel" });
      displayInfo.push({ infoField: "Update", infoData: "", infoKey: "updatedisable" });
      this.networkInfoDataSource.data = displayInfo;
    }
    catch (e) {
      console.log(e);
    }
    return tables;
  }

  viewNetworkInformationSection(tables: IceResponsiveMattableSettings[], editMode: boolean): IcepanelsectionSettings[] {
    let sections: IcepanelsectionSettings[] = [];
    try {
      let idGroups: IcepanelgroupSettings[] = [
        new IcepanelgroupSettings(null, tables)
      ];

      sections.push(
        new IcepanelsectionSettings("NetworkInformationSectionView", { class: ["yalla"], styles: { width: "100%" } }, idGroups, [], null)
      );

      /// Identification Edit Panel
      let dataCtrl = new IcecontrolSettings("iceautocomplete", { menuItems: [], width: "275px" }, null, null, "infoData", "Enter value")
        .setControlName("infoData")
        .createFormControl("", [Validators.required]);

      let datControls = [
        dataCtrl
      ];

      sections.push(this.appSvc.viewEditPanelSection(this.sectionTagEditNetworkInformation, datControls));
    }
    catch (e) {
      console.log(e);
    }
    return sections;
  }

  viewProviders(): IceResponsiveMattableSettings[] {
    let tables: IceResponsiveMattableSettings[] = [];
    try {

      let access: userTypes.USER_FEATURE_ACCESS = userTypes.USER_FEATURE_ACCESS.ufaNone;
      let ctrlPerm = this.getAppService().getPermission(userTypes.USER_FEATURES.ufProviderSearch);
      if (ctrlPerm)
        access = ctrlPerm.default_access;

      this.idTable = new IceResponsiveMattableSettings(
        this.tableTagPracticeProvider,
        [
          new iceColumnDefinition("first_name", "First name", false, false,
            new IcecontrolSettings("icelabel", { width: "50px" }, null, null)),
          new iceColumnDefinition("last_name", "Last name", false, false,
            new IcecontrolSettings("icelabel", { width: "50px" }, null, null)),
          new iceColumnDefinition("suffix", "Cred.", false, false,
            new IcecontrolSettings("icelabel", { width: "25px" }, null, null)),
          new iceColumnDefinition("identification", "IDs", false, false,
            new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
          new iceColumnDefinition("servicelevel", "Service Levels", false, false,
            new IcecontrolSettings("icelabel", { width: "50px" }, null, null)),
          new iceColumnDefinition("active_start_time", "Active Start", false, false,
            new IcecontrolSettings("icelabel", { width: "60px" }, null, null)),
          new iceColumnDefinition("active_end_time", "End Time", false, false,
            new IcecontrolSettings("icelabel", { width: "60px" }, null, null)),
          new iceColumnDefinition("address", "Primary Address", false, false,
            new IcecontrolSettings("icelabel", { width: "150px" }, null, null)),
          new iceColumnDefinition("contact", "Primary Contacts", false, false,
            new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
          new iceColumnDefinition("lastaddupdatedisablemessagekey", "Upload Message ID", false, false,
            new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
          new iceColumnDefinition("lastgetmessagekey", "Download Message ID", false, false,
            new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
          new iceColumnDefinition("updatedisable", "Upload Action", false, false,
            new IcecontrolSettings("icelabel", { width: "50px" }, null, null)),
          new iceColumnDefinition("trans_account", "trans_account", true),
          new iceColumnDefinition("QuickActions", "Download", false, false),
        ],
        this.providersDataSource,
        [IceTypes.recordQuickActionCloudDownload],
        false,
        null,
        true
      );

      tables.push(this.idTable);

      if (access != userTypes.USER_FEATURE_ACCESS.ufaNone) {
        this.proSvc.getPracticeProviders(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), "").subscribe(
          data => {
            if (data != null) {
              let displayPro = [];
              for (let ipro = 0; ipro < data.length; ipro++) {
                let adr = "";
                if (data[ipro]["street1"] != null) {
                  adr += data[ipro]["street1"];
                }

                if (data[ipro]["street2"] != null) {
                  adr += " " + data[ipro]["street2"];
                }

                if (data[ipro]["city"] != null) {
                  adr += " " + data[ipro]["city"];
                }

                if (data[ipro]["state_id"] != null) {
                  adr += ", " + data[ipro]["state_id"];
                }

                if (data[ipro]["postal_code"] != null) {
                  adr += ", " + data[ipro]["postal_code"];
                }

                if (data[ipro]["country_id"] != null) {
                  adr += ", " + data[ipro]["country_id"];
                }

                let ids = [];
                for (let i = 1; i <= 8; i++) {
                  let idCode: string = data[ipro]["identification_code" + i.toString()];
                  if (idCode == null || idCode.length == 0) continue;
                  ids.push(idCode);
                }

                if (data[ipro]["spi_num"] != null) {
                  ids.push(data[ipro]["spi_num"]);
                }

                let svclevels = [];
                let lvlDesc: string = data[ipro]["servicelevel"];
                let lvlParts = lvlDesc == null || lvlDesc.length == 0 ? [] : lvlDesc.split(",");
                for (let ilvl = 0; ilvl < lvlParts.length; ilvl++) {
                  svclevels.push(OrderService.getServiceLevel(<IceTypes.ServiceLevel>Iceutility.toLong(lvlParts[ilvl])));
                }

                let addmsgcode = data[ipro]["lastaddupdatedisablemessagecode"];
                let addmsgnote = data[ipro]["lastaddupdatedisablemessagenote"];
                let status = "";
                if (addmsgcode != null && addmsgcode.length > 0)
                  status = addmsgcode;

                if (addmsgnote != null && addmsgnote.length > 0)
                  status += " - " + addmsgnote;

                let pro = {
                  first_name: data[ipro]["first_name"],
                  last_name: data[ipro]["last_name"],
                  suffix: data[ipro]["suffix"],
                  trans_account: data[ipro]["trans_account"],
                  identification: ids.join(", "),
                  lastaddupdatedisablemessagekey: data[ipro]["lastaddupdatedisablemessagekey"],
                  lastgetmessagekey: data[ipro]["lastgetmessagekey"],
                  servicelevel: svclevels.join(", "),
                  changed_servicelevel: data[ipro]["servicelevel"],
                  active_start_time: Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(data[ipro]["active_start_time"])),
                  active_end_time: Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(data[ipro]["active_end_time"])),
                  address: adr,
                  contact: data[ipro]["phone_num"],
                  updatedisable: Iceutility.toBoolean(data[ipro]["updatedisable"]) ? this.providerUpdateDisplayValue : this.providerDisableDisplayValue,
                  object_reference: data[ipro],

                  // message fields
                  date_of_upload_message: "",
                  type_of_upload_message: "",
                  status_of_upload_message: status
                }
                displayPro.push(pro);

                if (pro["lastaddupdatedisablemessagekey"] != null && pro["lastaddupdatedisablemessagekey"].length > 0) {
                  this.messageSvc.getMessage(pro["lastaddupdatedisablemessagekey"], true).subscribe(
                    data => {
                      if (data == null || data.length == 0) return;

                      let msg: message = <message>data[0];
                      pro.date_of_upload_message = Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(msg.message_date));
                      pro.type_of_upload_message = MessageService.getTransTypeText(Iceutility.toLong(msg.trans_type));

                      if (msg.ATTACHMENTS.length > 0) {
                        let ach = msg.ATTACHMENTS[0];
                        this.messageSvc.getMessageAttachment(msg.message_key, ach.external_data_key, ach.parent_src_type/*to do, msg.from*/).subscribe(
                          attch => {
                            if (attch == null) return;
                            let res: string = attch.replace("<?xml version='1.0' encoding='utf-8'?>", "");
                            let dat = "<?xml version='1.0' encoding='utf-8'?>";
                            dat += "<ICEXDocument>" + res + "</ICEXDocument>";
                            let directMessage: SS.ss_message[] = <SS.ss_message[]>this.messageSvc.geticexdocumentobjects(dat, ["DirectoryMessage"]);
                            if (directMessage == null || directMessage.length == 0) return;
                            if (directMessage[0].Body == null || directMessage[0].Body.length == 0) return;
                            let body = directMessage[0].Body[0];
                            if (body == null || body == null) return;
                            if (body.Status != null && body.Status.length > 0) {
                              let statNode = body.Status[0];
                              if (statNode != null) {
                                let statDesc = "";
                                if (statNode["description"] != null) statDesc = statNode["description"];
                                if (statNode["code"] == "010") statDesc += "(" + "successfully uploaded" + ")";
                                pro.status_of_upload_message = statNode["code"] + " - " + statDesc;
                              }
                            }
                            else if (body.Error != null && body.Error.length > 0) {
                              let errNode = body.Error[0];
                              if (errNode != null) {
                                pro.status_of_upload_message = errNode["code"] + " - " + errNode["description"];
                              }
                            }
                          },
                          error => {

                          }
                        )
                      }
                    },
                    error => {
                    }
                  );
                }
              }
              this.providersDataSource.data = displayPro;
            }
          },
          error => {
            // To do error
          }
        );
      }
    }
    catch (e) {
      console.log(e);
    }
    return tables;
  }

  viewProvidersSection(tables: IceResponsiveMattableSettings[], editMode: boolean): IcepanelsectionSettings[] {
    let sections: IcepanelsectionSettings[] = [];
    try {
      let idGroups: IcepanelgroupSettings[] = [
        new IcepanelgroupSettings(null, tables)
      ];

      sections.push(
        new IcepanelsectionSettings("ProvidersViewSection", { class: [""], styles: { width: "100%" } }, idGroups, [], null)
      );

      /// Identification Edit Panel
      let startCtrl = new IcecontrolSettings("icedatepicker", { width: "150px" }, null, null, "active_start_time", "Enter SPI Active Start Date")
        .setControlName("active_start_time")
        .createFormControl("", [Validators.required]);

      let endCtrl = new IcecontrolSettings("icedatepicker", { width: "150px" }, null, null, "active_end_time", "Enter SPI Active End Date")
        .setControlName("active_end_time")
        .createFormControl("", [Validators.required]);

      let updateDisableCtrl  = new IcecontrolSettings("iceslidetoggle",
        { placeholder: "Upload Action: ", onDisplayValue: this.providerUpdateDisplayValue, offDisplayValue: this.providerDisableDisplayValue, width: "100px" },
        null, null, "updatedisable")
        .setControlName("updatedisable")
        .createFormControl(false, [Validators.required]);

      let svcLvlCtrl = new IcecontrolSettings("iceautocomplete", { menuItems: [], width: "450px" }, null, null, "servicelevel", "Enter Service Level (i.e. New Rx)")
        .setControlName("servicelevel")
        .createFormControl([], [Validators.required])
        .setMultipleSelection(true);

      let svcLvlOpts = svcLvlCtrl.getOptions();
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelNew), value: IceTypes.ServiceLevel.svcLevelNew });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelRefill), value: IceTypes.ServiceLevel.svcLevelRefill });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelChange), value: IceTypes.ServiceLevel.svcLevelChange });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelRxFill), value: IceTypes.ServiceLevel.svcLevelRxFill });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelCancel), value: IceTypes.ServiceLevel.svcLevelCancel });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelMedHistory), value: IceTypes.ServiceLevel.svcLevelMedHistory });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelReSupp), value: IceTypes.ServiceLevel.svcLevelReSupp });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelCensus), value: IceTypes.ServiceLevel.svcLevelCensus });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelCCR), value: IceTypes.ServiceLevel.svcLevelCCR });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelControlledSubstance), value: IceTypes.ServiceLevel.svcLevelControlledSubstance });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelCIMessage), value: IceTypes.ServiceLevel.svcLevelCIMessage });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelCIEvent), value: IceTypes.ServiceLevel.svcLevelCIEvent });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelePA), value: IceTypes.ServiceLevel.svcLevelePA });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelLongTermCare), value: IceTypes.ServiceLevel.svcLevelLongTermCare });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelRxFillIndicatorChange), value: IceTypes.ServiceLevel.svcLevelRxFillIndicatorChange });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelDrugAdministration), value: IceTypes.ServiceLevel.svcLevelDrugAdministration });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelNewRxRequest), value: IceTypes.ServiceLevel.svcLevelNewRxRequest });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelNewRxResponseDenied), value: IceTypes.ServiceLevel.svcLevelNewRxResponseDenied });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelRecertification), value: IceTypes.ServiceLevel.svcLevelRecertification });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelPatMedBenefitCheck), value: IceTypes.ServiceLevel.svcLevelPatMedBenefitCheck });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelSpecialty), value: IceTypes.ServiceLevel.svcLevelSpecialty });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelRxTransfer), value: IceTypes.ServiceLevel.svcLevelRxTransfer });
      svcLvlOpts.push({ name: OrderService.getServiceLevel(IceTypes.ServiceLevel.svcLevelSPOAutoEnrollment), value: IceTypes.ServiceLevel.svcLevelSPOAutoEnrollment });

      let uploadKeyCtrl = new IcecontrolSettings("icelabel", { width: "50px", value: "Last Upload Message ID: " }, null, null, "lastaddupdatedisablemessagekey", "No uploads")
        .setControlName("lastaddupdatedisablemessagekey")
        .createFormControl("", []);

      let dateOfUploadMessageCtrl = new IcecontrolSettings("icelabel", { width: "50px", value: "Date of Message: " }, null, null, "date_of_upload_message", "Date of Message: ")
        .setControlName("date_of_upload_message")
        .createFormControl("", []);

      let typeOfUploadMessageCtrl = new IcecontrolSettings("icelabel", { width: "50px", value: "Type of Message: " }, null, null, "type_of_upload_message", "Type of Message: ")
        .setControlName("type_of_upload_message")
        .createFormControl("", []);

      let statusOfUploadMessageCtrl = new IcecontrolSettings("icelabel", { width: "50px", value: "Status of Message: " }, null, null, "status_of_upload_message", "Status of Message: ")
        .setControlName("status_of_upload_message")
        .createFormControl("", []);

      let proControls = [
        startCtrl,
        endCtrl,
        updateDisableCtrl,
        svcLvlCtrl,
        uploadKeyCtrl,
        dateOfUploadMessageCtrl,
        typeOfUploadMessageCtrl,
        statusOfUploadMessageCtrl
      ];

      sections.push(this.appSvc.viewEditPanelSection(this.sectionTagEditPracticeProvider, proControls));
    }
    catch (e) {
      console.log(e);
    }
    return sections;
  }

  viewSetup(dat: IceEntity): IcepanelcontainerSettings {
    return null;
  }

  public setNewOutboundDomainNameList(domainType: IceTypes.ACCOUNT_TYPE) {
    this.newOutboundDomainNameCtrl.setOptions([]);

    switch (domainType) {
      case IceTypes.ACCOUNT_TYPE.actVendor: {
        this.vendorSvc.getVendors().subscribe(
          data => {
            if (data && data.length > 0 && data[0] != null) {
              let opts = data.map(m => { return { value: m.trans_account, name: m.getdisplayname() } });
              this.newOutboundDomainNameCtrl.setOptions(this.newOutboundDomainNameCtrl.getOptions().concat(opts));
            }
          },
          error => {
            console.log(JSON.stringify(this.domainSvc.getLastErrors()));
          });
        break;
      }
      default: {
        // To do error to user
        return;
      }
    }
  }

  public setIDCodeList(ctrl: IcecontrolSettings, codes: string[]) {
    if (ctrl == null) return;

    ctrl.setOptions([]);
    this.medCodeSvc.getCodes("IDENTIFICATION_CODE_QUALIFIER", "", codes.join(','), "").subscribe(
      data => {
        if (data && data.length > 0 && data[0] != null) {
          let opts = data.map(c => { return { value: c.code, name: c.title + " (" + c.code +")" } });
          opts.sort(function (a, b) { return a.name.localeCompare(b.name) });
          ctrl.setOptions(ctrl.getOptions().concat(opts));
          this.idOptions = ctrl.getOptions(); // save options

          this.identificationDataSource.data
          for (let iId = 0; iId < this.identificationDataSource.data.length; iId++) {
            let idObj = this.identificationDataSource.data[iId];
            if (idObj == null) continue;

            let optList = ctrl.getOptions().filter(opt => idObj["identification_code_qualifier"] == opt.value);
            if (optList.length > 0) {
              this.identificationDataSource.data[iId]["identification_code_qualifier"] = optList[0].name; 
            }
          }
        }
      },
      error => {
        console.log(JSON.stringify(this.medCodeSvc.getLastErrors()));
      });
  }

  public setTaxonomyCodeList(codes: string[]) {
    if (this.taxonomyCodeCtrl == null) return;

    this.taxonomyCodeCtrl.setOptions([]);
    this.medCodeSvc.getCodes("TAXONOMY", "", codes.join(','), "").subscribe(
      data => {
        if (data && data.length > 0 && data[0] != null) {
          let opts = data.map(c => { return { value: c.code, name: c.description + " (" + c.code + ")" } });
          opts.sort(function (a, b) { return a.name.localeCompare(b.name) });
          this.taxonomyCodeCtrl.setOptions(this.taxonomyCodeCtrl.getOptions().concat(opts));

          let optList = opts.filter(opt => this.taxonomyCodeCtrl.getFormControl().value == opt.value);
          if (optList.length > 0) {
            this.taxonomyCodeCtrl.getFormControl().setValue(optList[0].name);
          }
        }
      },
      error => {
        console.log(JSON.stringify(this.medCodeSvc.getLastErrors()));
      });
  }

  public setCodeList(obj: basecode, ctrl: IcecontrolSettings, codes: string[]) {
    this.appSvc.setCodeList(this.medCodeSvc, obj, ctrl, codes);
  }

  public setLicenseList(ctrl: IcecontrolSettings, countries: basecode[], currencies: basecode[], defaultLics: string[]) {
    if (ctrl == null) return;

    ctrl.setOptions([]);
    this.getDomainService().getLicences().subscribe(
      data => {
        if (data && data.length > 0 && data[0] != null) {
          let opts = [];
          for (let iLic = 0; iLic < data.length; iLic++) {
            let licObj: licenseobject = data[iLic];
            if (licObj == null) continue;

            // lic condition
            if (Iceutility.toBoolean(licObj.disabled)) continue;

            if (licObj.account_type == this.appSvc.getCurrentAccountType()) {

              // filter out countries
              if (false == this.getDomainService().supportedLicenseCountry(licObj, countries)) {
                continue;
              }

              // filter out currencies
              if (false == this.getDomainService().supportedLicenseCurrency(licObj, currencies)) {
                continue;
              }

              // set default lics defaultLics

              licObj["temp_image"] = "./assets/default_blog_image.png";

              opts.push(licObj);
            }
          }
          ctrl.setOptions(opts);

          if (opts.length > 0) {
            // append title caption with  "Click to Buy =>"
            this.subTable.showAddButton(true);
          }
          else {
            this.getDomainService().logMessage(IceTypes.LOGTYPE.ltWarning, "You will need to set your default country and currency to purchase subscriptions.");
          }

          // Set Totals
          ctrl.properties.subTotal = 0.0;
          ctrl.properties.otherFees = 0.0;
          ctrl.properties.grandTotal = 0.0;
          ctrl.properties.lastErrors = null;

          if (currencies.length > 0)
            ctrl.properties.defaultCountry = countries[0].code;
          else
            ctrl.properties.defaultCountry = "USA";

          if (currencies.length > 0)
            ctrl.properties.defaultCurrency = currencies[0].code;
          else
            ctrl.properties.defaultCurrency = "USD";
        }
      },
      error => {
        console.log(JSON.stringify(this.medCodeSvc.getLastErrors()));
      });
  }

  setSubscriptions(): void {
    this.domainSvc.getSubscriptions(this.appSvc.getCurrentAccountType(), this.appSvc.getCurrentAccount()).subscribe(
      data => {
        if (data && data.length > 0) {
          let displaySubs = [];
          for (let isub = 0; isub < data.length; isub++) {

            let sub: subscriptionobject = <subscriptionobject>data[isub];

            let dt = null;
            if (!isNaN(sub.date_renewed))
              dt = sub.date_renewed;
            else
              dt = sub.inception_date;

            let dSub = {
              title: sub.title,
              features: sub.features,
              summary: sub.getSummary().join(";"),
              date: Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(dt)),
              rate: sub.rate.toString() + " " + sub.currency_code,
              subscription_key: sub.subscription_key,
            };
            displaySubs.push(dSub);
          }
          this.subscriptionDataSource.data = displaySubs;
        }
        else {
          this.appSvc.showEditPanelSection(this.sectionTagSubscriptionPayment);
          this.appSvc.hideEditPanelSection(this.sectionTagPaymentReceipt);
          this.appSvc.editPanelSectionUpdate(this.sectionTagSubscriptionPayment, false, {});
        }
      },
      error => {
        console.log(JSON.stringify(this.medCodeSvc.getLastErrors()));
      });
  }

  addNewOutboundDomainConnection(conn: connectionparameters, typeref: transtypereference) {
    let transtypecode = IceTypes.TRANSTYPE.itNone;
    let serverconnparameterskey = "";
    let testrequired = false;

    if (typeref != null) {
      transtypecode = typeref.trans_type_code;
      serverconnparameterskey = typeref.server_connection_parameters_key;
      testrequired = typeref.test_required;
    }

    let dCon = {
      connection_title: conn.connection_title,
      application: MessageService.getTransTypeDesc(transtypecode),
      trans_account: conn.trans_account,
      account_type: conn.account_type,
      trans_type_code: transtypecode,
      application_code: conn.application_code,
      server_user_name: conn.server_user_name,
      server_password: conn.server_password,
      test_required: Iceutility.toBoolean(testrequired),
      server_connection_parameters_key: serverconnparameterskey,
      connection_parameters_key: conn.connection_parameters_key,
    };

    if (this.outboundParamsDataSource.data == null)
      this.outboundParamsDataSource.data = [];

    this.outboundParamsDataSource.data.push(dCon);
    this.outboundParamsDataSource.data = this.outboundParamsDataSource.data;
  }

  getNewOutboundDomainConnection(): any {
    let type = this.newOutboundDomainTypeCtrl.getFormControl().value;
    let nameVal = this.newOutboundDomainNameCtrl.getFormControl().value;
    let appVal = this.newOutboundDomainApplicaionCtrl.getFormControl().value;

    let conn = null;
    let typeref = null;
    try {
      let nameObj = JSON.parse(nameVal);
      if (nameObj == null || nameObj.length == 0) throw "Invalid domain selection.";

      let fldValue: string = <string>appVal;
      let flds = fldValue.split("|");
      if (flds.length < 7) "Unable to determine application parameters.";

      conn = new connectionparameters();
      conn.connection_parameters_key = Iceutility.guid(true);
      conn.account_type = type;
      conn.trans_account = nameObj[0].value;
      conn.connection_title = nameObj[0].name + " - " + flds[6];
      conn.server_user_name = "";
      conn.server_password = "";
      conn.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
      typeref = new transtypereference();
      typeref.trans_type_reference_key = Iceutility.guid(true);
      typeref.connection_parameters_key = conn.connection_parameters_key;
      typeref.server_connection_parameters_key = flds[0];
      typeref.trans_type_code = <IceTypes.TRANSTYPE>Iceutility.toLong(flds[1]);
      typeref.test_required = Iceutility.toBoolean(flds[4]);
      typeref.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
    }
    catch (e) {
      console.log(e);
    }

    return {
      conn: conn,
      typeref: typeref
    };
  }

  addNewInboundDomainConnection(conn: connectionparameters, type: transtype) {
    let transtypecode = IceTypes.TRANSTYPE.itNone;
    let testrequired = false;
    let disabled = false;
    let underdevelopment = false;
    let participating_type = IceTypes.participation_type.pptNonParticipating;
    let contract_required = false;
    let must_contact = false;
    let transport_format = IceTypes.DATA_TRANSPORT_FORMAT.datatfmtNone;
    let connection_type = IceTypes.CONNECTIONTYPE.conntypNone;
    let protocol_type = IceTypes.PROTOCOL.protocolNone;
    let protocol_version = "";
    let protocol_api = IceTypes.PROTOCOLAPI.papiURL;
    let protocol_api_version = "";
    if (type != null) {
      transtypecode = type.trans_type_code;
      testrequired = type.test_required;
      underdevelopment = type.underdevelopment;
      participating_type = type.participating_type;
      contract_required = type.contract_required;
      must_contact = type.must_contact;
      transport_format = <IceTypes.DATA_TRANSPORT_FORMAT>type.transport_format;
      connection_type = <IceTypes.CONNECTIONTYPE>type.connection_type;
      protocol_type = <IceTypes.PROTOCOL>type.protocol_type;
      protocol_version = type.protocol_version;
      protocol_api = <IceTypes.PROTOCOLAPI>type.protocol_api;
      protocol_api_version = type.protocol_api_version;
    }

    let dCon = {
      connection_title: conn.connection_title,
      application: MessageService.getTransTypeDesc(transtypecode),
      disabled: Iceutility.toBoolean(type.disabled),
      trans_account: conn.trans_account,
      account_type: conn.account_type,
      trans_type_code: transtypecode,
      application_code: conn.application_code,
      server_user_name: conn.server_user_name,
      server_password: conn.server_password,
      test_required: Iceutility.toBoolean(testrequired),
      underdevelopment: Iceutility.toBoolean(underdevelopment),
      participating_type: MessageService.getParticipatingTypeDesc(participating_type),
      contract_required: Iceutility.toBoolean(contract_required),
      must_contact: Iceutility.toBoolean(must_contact),
      ip: conn.ip,
      folder: conn.folder,
      root_name: conn.root_name,
      transport_format: MessageService.getDataTransportFormatDesc(transport_format),
      connection_type: MessageService.getConnectionTypeDesc(connection_type),
      protocol_type: MessageService.getProtocolDesc(protocol_type),
      protocol_version: protocol_version,
      protocol_api: MessageService.getProtocolAPIDesc(protocol_api),
      protocol_api_version: protocol_api_version,
      connection_parameters_key: conn.connection_parameters_key,
    };

    if (this.inboundParamsDataSource.data == null)
      this.inboundParamsDataSource.data = [];

    this.inboundParamsDataSource.data.push(dCon);
    this.inboundParamsDataSource.data = this.inboundParamsDataSource.data;
  }

  addNewContact(con: contact) {

    let typeName = con.communication_type;
    let optList = MedicalcodesService.getContactTypeList().filter(opt => con.communication_type == opt.value);
    if (optList.length > 0) {
      typeName = optList[0].name;
    }

    let methodName = con.communication_number_qualifier;
    optList = MedicalcodesService.getContactMethodList().filter(opt => con.communication_number_qualifier == opt.value);
    if (optList.length > 0) {
      methodName = optList[0].name;
    }

    let dCon = {
      communication_number_qualifier: methodName,
      communication_type: typeName,
      communication_number: con.communication_number,
      contact_key: con.contact_key
    };

    if (this.contactDataSource.data == null)
      this.contactDataSource.data = [];

    this.contactDataSource.data.push(dCon);
    this.contactDataSource.data = this.contactDataSource.data;
  }

  addNewAddress(adr: address) {
    let typeName = adr.address_type;
    let optList = MedicalcodesService.getAddressTypeList().filter(opt => adr.address_type == opt.value);
    if (optList.length > 0) {
      typeName = optList[0].name;
    }

    let dAd = {
      address_type: typeName,
      street1: adr.street1,
      street2: adr.street2,
      city: adr.city,
      state_id: adr.state_id,
      postal_code: adr.postal_code,
      country_id: adr.country_id,
      address_key: adr.address_key,
    };

    if (this.addressDataSource.data == null)
      this.addressDataSource.data = [];

    this.addressDataSource.data.push(dAd);
    this.addressDataSource.data = this.addressDataSource.data;
  }

  addNewIdentification(id: identification) {
    let dId = {
      identification_code_qualifier: id.identification_code_qualifier,
      identification_code: id.identification_code,
      identification_key: id.identification_key,
    };

    if (this.identificationDataSource.data == null)
      this.identificationDataSource.data = [];

    this.identificationDataSource.data.push(dId);
    this.identificationDataSource.data = this.identificationDataSource.data;
  }

  editOutboundUpdate(update: boolean, rowData: any) {
    if (rowData == null) return;

    if (update == false) {
      this.editOutboundRow = rowData;

      let titleCtrl = this.getEditOutboundTitleControl();
      if (titleCtrl) {
        titleCtrl.getFormControl().setValue(rowData["connection_title"]);
      }

      let appCtrl = this.getEditOutboundApplicationControl();
      if (appCtrl) {
        appCtrl.getFormControl().setValue(rowData["application"]);
      }

      let codeCtrl = this.getEditOutboundCodeControl();
      if (codeCtrl) {
        codeCtrl.getFormControl().setValue(rowData["application_code"]);
      }

      let usernameCtrl = this.getEditOutboundUsernameControl();
      if (usernameCtrl) {
        usernameCtrl.getFormControl().setValue(rowData["server_user_name"]);
      }

      let passwordCtrl = this.getEditOutboundPasswordControl();
      if (passwordCtrl) {
        passwordCtrl.getFormControl().setValue(rowData["server_password"]);
      }
    }
    else {
      let codeCtrl = this.getEditOutboundCodeControl();
      if (codeCtrl) {
        rowData["application_code"] = codeCtrl.getFormControl().value;
      }

      let usernameCtrl = this.getEditOutboundUsernameControl();
      if (usernameCtrl) {
        rowData["server_user_name"] = usernameCtrl.getFormControl().value;
      }

      let passwordCtrl = this.getEditOutboundPasswordControl();
      if (passwordCtrl) {
        rowData["server_password"] = passwordCtrl.getFormControl().value;
      }
      let frmGrp = this.outboundTable.getFormGroupByPrimaryKey(rowData["connection_parameters_key"]);
      if (frmGrp) frmGrp.markAsDirty();

      this.editOutboundRow = null;
    }
  }

  editInboundUpdate(update: boolean, rowData: any) {
    if (rowData == null) return;

    if (update == false) {
      this.editInboundRow = rowData;

      let connTitleCtrl = this.getEditInboundConnectionTitleControl();
      if (connTitleCtrl) {
        connTitleCtrl.getFormControl().setValue(rowData["connection_title"]);
      }

      let appCtrl = this.getEditInboundDomainApplicaionControl();
      if (appCtrl) {
        appCtrl.getFormControl().setValue(MessageService.getTransTypeValueFromDesc(rowData["application"]));
      }

      let codeCtrl = this.getEditInboundCodeControl();
      if (codeCtrl) {
        codeCtrl.getFormControl().setValue(rowData["application_code"]);
      }

      let usernameCtrl = this.getEditInboundUsernameControl();
      if (usernameCtrl) {
        usernameCtrl.getFormControl().setValue(rowData["server_user_name"]);
      }

      let passwordCtrl = this.getEditInboundPasswordControl();
      if (passwordCtrl) {
        passwordCtrl.getFormControl().setValue(rowData["server_password"]);
      }
      
      let statusCtrl = this.getEditInboundStatusControl();
      if (statusCtrl) {
        statusCtrl.getFormControl().setValue(rowData["disabled"]);
      }

      let participatingCtrl = this.getEditInboundParticipatingControl();
      if (participatingCtrl) {
        participatingCtrl.getFormControl().setValue(MessageService.getParticipatingTypeValueFromDesc(rowData["participating_type"]));
      }
      
      let devCtrl = this.getEditInboundTestModeControl();
      if (devCtrl) {
        devCtrl.getFormControl().setValue(Iceutility.toBoolean(rowData["underdevelopment"]));
      }

      let contractReqCtrl = this.getEditInboundContractRequiredControl();
      if (contractReqCtrl) {
        contractReqCtrl.getFormControl().setValue(Iceutility.toBoolean(rowData["contract_required"]));
      }

      let mustContactCtrl = this.getEditInboundMustContactControl();
      if (mustContactCtrl) {
        mustContactCtrl.getFormControl().setValue(Iceutility.toBoolean(rowData["must_contact"]));
      }

      let testReqCtrl = this.getEditInboundTestRequiredControl();
      if (testReqCtrl) {
        testReqCtrl.getFormControl().setValue(Iceutility.toBoolean(rowData["test_required"]));
      }

      let ipCtrl = this.getEditInboundServerControl();
      if (ipCtrl) {
        ipCtrl.getFormControl().setValue(rowData["ip"]);
      }

      let folderCtrl = this.getEditInboundFolderControl();
      if (folderCtrl) {
        folderCtrl.getFormControl().setValue(rowData["folder"]);
      }

      let appParamCtrl = this.getEditInboundAppParamControl();
      if (appParamCtrl) {
        appParamCtrl.getFormControl().setValue(rowData["root_name"]);
      }

      let formatCtrl = this.getEditInboundDataFormatControl();
      if (formatCtrl) {
        formatCtrl.getFormControl().setValue(MessageService.getDataTransportFormatValueFromDesc(rowData["transport_format"]));
      }

      let connTypeCtrl = this.getEditInboundConnectionTypeControl();
      if (connTypeCtrl) {
        connTypeCtrl.getFormControl().setValue(MessageService.getConnectionTypeValueFromDesc(rowData["connection_type"]));
      }

      let protocolCtrl = this.getEditInboundProtocolControl();
      if (protocolCtrl) {
        protocolCtrl.getFormControl().setValue(MessageService.getProtocolValueFromDesc(rowData["protocol_type"]));
      }

      let protocolVerCtrl = this.getEditInboundProtocolVersionControl();
      if (protocolVerCtrl) {
        protocolVerCtrl.getFormControl().setValue(rowData["protocol_version"]);
      }

      let protocolAPICtrl = this.getEditInboundProtocolAPIControl();
      if (protocolAPICtrl) {
        protocolAPICtrl.getFormControl().setValue(MessageService.getProtocolAPIValueFromDesc(rowData["protocol_api"]));
      }

      let protocolAPIVerCtrl = this.getEditInboundProtocolAPIVersionControl();
      if (protocolAPIVerCtrl) {
        protocolAPIVerCtrl.getFormControl().setValue(rowData["protocol_api_version"]);
      }
    }
    else {
      let connTitleCtrl = this.getEditInboundConnectionTitleControl();
      if (connTitleCtrl) {
        rowData["connection_title"] = connTitleCtrl.getFormControl().value;
      }

      let appCtrl = this.getEditInboundDomainApplicaionControl();
      if (appCtrl) {
        rowData["application"] = MessageService.getTransTypeDesc(appCtrl.getFormControl().value);
      }
      
      let codeCtrl = this.getEditInboundCodeControl();
      if (codeCtrl) {
        rowData["application_code"] = codeCtrl.getFormControl().value;
      }

      let usernameCtrl = this.getEditInboundUsernameControl();
      if (usernameCtrl) {
        rowData["server_user_name"] = usernameCtrl.getFormControl().value;
      }

      let passwordCtrl = this.getEditInboundPasswordControl();
      if (passwordCtrl) {
        rowData["server_password"] = passwordCtrl.getFormControl().value;
      }

      let statusCtrl = this.getEditInboundStatusControl();
      if (statusCtrl) {
        rowData["disabled"] = statusCtrl.getFormControl().value;
      }

      let participatingCtrl = this.getEditInboundParticipatingControl();
      if (participatingCtrl) {
        rowData["participating_type"] = MessageService.getParticipatingTypeDesc(participatingCtrl.getFormControl().value);
      }

      let devCtrl = this.getEditInboundTestModeControl();
      if (devCtrl) {
        rowData["underdevelopment"] = Iceutility.toBoolean(devCtrl.getFormControl().value);
      }

      let contractReqCtrl = this.getEditInboundContractRequiredControl();
      if (contractReqCtrl) {
        rowData["contract_required"] = Iceutility.toBoolean(contractReqCtrl.getFormControl().value);
      }

      let mustContactCtrl = this.getEditInboundMustContactControl();
      if (mustContactCtrl) {
        rowData["must_contact"] = Iceutility.toBoolean(mustContactCtrl.getFormControl().value);
      }

      let testReqCtrl = this.getEditInboundTestRequiredControl();
      if (testReqCtrl) {
        rowData["test_required"] = Iceutility.toBoolean(testReqCtrl.getFormControl().value);
      }

      let ipCtrl = this.getEditInboundServerControl();
      if (ipCtrl) {
        rowData["ip"] = ipCtrl.getFormControl().value;
      }

      let folderCtrl = this.getEditInboundFolderControl();
      if (folderCtrl) {
        rowData["folder"] = folderCtrl.getFormControl().value;
      }

      let appParamCtrl = this.getEditInboundAppParamControl();
      if (appParamCtrl) {
        rowData["root_name"] = appParamCtrl.getFormControl().value;
      }

      let formatCtrl = this.getEditInboundDataFormatControl();
      if (formatCtrl) {
        rowData["transport_format"] = MessageService.getDataTransportFormatDesc(formatCtrl.getFormControl().value);
      }

      let connTypeCtrl = this.getEditInboundConnectionTypeControl();
      if (connTypeCtrl) {
        rowData["connection_type"] = MessageService.getConnectionTypeDesc(connTypeCtrl.getFormControl().value);
      }

      let protocolCtrl = this.getEditInboundProtocolControl();
      if (protocolCtrl) {
        rowData["protocol_type"] = MessageService.getProtocolDesc(protocolCtrl.getFormControl().value);
      }

      let protocolVerCtrl = this.getEditInboundProtocolVersionControl();
      if (protocolVerCtrl) {
        rowData["protocol_version"] = protocolVerCtrl.getFormControl().value;
      }

      let protocolAPICtrl = this.getEditInboundProtocolAPIControl();
      if (protocolAPICtrl) {
        rowData["protocol_api"] = MessageService.getProtocolAPIDesc(protocolAPICtrl.getFormControl().value);
      }

      let protocolAPIVerCtrl = this.getEditInboundProtocolAPIVersionControl();
      if (protocolAPIVerCtrl) {
        rowData["protocol_api_version"] = protocolAPIVerCtrl.getFormControl().value;
      }

      let frmGrp = this.inboundTable.getFormGroupByPrimaryKey(rowData["connection_parameters_key"]);
      if (frmGrp) frmGrp.markAsDirty();

      this.editInboundRow = null;
    }
  }

  updateName(countries: basecode[], currencies: basecode[]): boolean {
    if (this.countryCodeCtrl != null) {
      let defCountryCode = "";
      let defCountryName = "";
      let cntryFrmCtrl = this.countryCodeCtrl.getFormControl();
      if (cntryFrmCtrl && cntryFrmCtrl.dirty) {
        defCountryCode = cntryFrmCtrl.value;
        let optList = this.countryCodeCtrl.getOptions().filter(opt => cntryFrmCtrl.value == opt.value);
        if (optList.length > 0) {
          defCountryName = optList[0].name;
        }

        if (defCountryCode.length == 0) {
          this.getDomainService().logMessage(IceTypes.LOGTYPE.ltError, "The Country code field is required.");
          return false;
        }

        if (countries.length == 0) {
          countries = [new basecode("COUNTRY")];
        }

        countries[0].code = defCountryCode;
        countries[0].title = defCountryName;
      }
    }

    if (this.currencyCodeCtrl != null) {
      let defCurrencyCode = "";
      let defCurrencyName = "";
      let curFrmCtrl = this.currencyCodeCtrl.getFormControl();
      if (curFrmCtrl && curFrmCtrl.dirty) {
        defCurrencyCode = curFrmCtrl.value;
        let optList = this.currencyCodeCtrl.getOptions().filter(opt => curFrmCtrl.value == opt.value);
        if (optList.length > 0) {
          defCurrencyName = optList[0].name;
        }

        if (defCurrencyCode.length == 0) {
          this.getDomainService().logMessage(IceTypes.LOGTYPE.ltError, "The Currency code field is required.");
          return false;
        }

        if (currencies.length == 0) {
          currencies = [new basecode("CURRENCY")];
        }

        currencies[0].code = defCurrencyCode;
        currencies[0].title = defCurrencyName;
      }
    }

    return true;
  }

  updateOutboundDomainConnection(conns: connectionparameters[], typerefs: transtypereference[]) {
    for (let iout = 0; iout < this.outboundParamsDataSource.data.length; iout++) {
      let outConn = this.outboundParamsDataSource.data[iout];

      let storedConns = conns.filter(c => {
        return c.connection_parameters_key == outConn["connection_parameters_key"]
      });

      let frmGrp = this.outboundTable.getFormGroupByPrimaryKey(outConn["connection_parameters_key"]);
      if (storedConns.length > 0 && frmGrp && frmGrp.dirty) {
        if (storedConns[0].offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          storedConns[0].offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
        storedConns[0].server_user_name = frmGrp.get("server_user_name").value;
        storedConns[0].server_password = frmGrp.get("server_password").value;
        storedConns[0].application_code = frmGrp.get("application_code").value;
      }

      let storedTypeRefs = typerefs.filter(t => {
        return t.connection_parameters_key == outConn["connection_parameters_key"]
      });
      if (storedTypeRefs.length > 0 && frmGrp && frmGrp.dirty) {
        if (storedTypeRefs[0].offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          storedTypeRefs[0].offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        storedTypeRefs[0].trans_type_code = typeof frmGrp.get("application").value === "string" ? MessageService.getTransTypeValueFromDesc(frmGrp.get("application").value) : frmGrp.get("application").value;
      }
    }
  }

  updateInboundDomainConnection(conns: connectionparameters[], types: transtype[]) {
    for (let iout = 0; iout < this.inboundParamsDataSource.data.length; iout++) {
      let inConn = this.inboundParamsDataSource.data[iout];

      let storedConns = conns.filter(c => {
        return c.connection_parameters_key == inConn["connection_parameters_key"]
      });

      if (storedConns.length > 0) {
        if (storedConns[0].offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          storedConns[0].offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
        storedConns[0].connection_title = inConn["connection_title"];
        storedConns[0].server_user_name = inConn["server_user_name"];
        storedConns[0].server_password = inConn["server_password"];
        storedConns[0].application_code = inConn["application_code"];
        storedConns[0].ip = inConn["ip"];
        storedConns[0].folder = inConn["folder"];
        storedConns[0].root_name = inConn["root_name"];
      }

      let storedTypes = types.filter(t => {
        return t.connection_parameters_key == inConn["connection_parameters_key"]
      });
      if (storedTypes.length > 0) {
        if (storedTypes[0].offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          storedTypes[0].offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        storedTypes[0].trans_type_code = typeof inConn["application"] === "string" ? MessageService.getTransTypeValueFromDesc(inConn["application"]) : inConn["application"];
        storedTypes[0].disabled = inConn["disabled"];
        storedTypes[0].test_required = inConn["test_required"];
        storedTypes[0].underdevelopment = inConn["underdevelopment"];
        storedTypes[0].participating_type = typeof inConn["participating_type"] === "string" ? MessageService.getParticipatingTypeValueFromDesc(inConn["participating_type"]) : inConn["participating_type"];
        storedTypes[0].contract_required = inConn["contract_required"];
        storedTypes[0].must_contact = inConn["must_contact"];
        storedTypes[0].transport_format = typeof inConn["transport_format"] === "string" ? MessageService.getDataTransportFormatValueFromDesc(inConn["transport_format"]) : inConn["transport_format"];
        storedTypes[0].connection_type = typeof inConn["connection_type"] === "string" ? MessageService.getConnectionTypeValueFromDesc(inConn["connection_type"]) : inConn["connection_type"];
        storedTypes[0].protocol_type = typeof inConn["protocol_type"] === "string" ? MessageService.getProtocolValueFromDesc(inConn["protocol_type"]) : inConn["protocol_type"];
        storedTypes[0].protocol_version = inConn["protocol_version"];
        storedTypes[0].protocol_api = MessageService.getProtocolAPIValueFromDesc(inConn["protocol_api"]);
        storedTypes[0].protocol_api_version = inConn["protocol_api_version"];
      }
    }
  }

  updateIdentification(ids: identification[]) {
    for (let iid = 0; iid < this.identificationDataSource.data.length; iid++) {
      let idObj = this.identificationDataSource.data[iid];

      let storedIds = ids.filter(id => {
        return id.identification_key == idObj["identification_key"]
      });

      if (storedIds.length > 0) {
        if (storedIds[0].offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          storedIds[0].offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        let optList = this.idOptions.filter(opt => idObj["identification_code_qualifier"] == opt.name);
        if (optList.length > 0) {
          storedIds[0].identification_code_qualifier = optList[0].value;
        }

        storedIds[0].identification_code = idObj["identification_code"];
      }
    }
  }

  updateAddress(ads: address[]) {
    for (let iad = 0; iad < this.addressDataSource.data.length; iad++) {
      let adObj = this.addressDataSource.data[iad];

      let storedAds = ads.filter(ad => {
        return ad.address_key == adObj["address_key"]
      });

      if (storedAds.length > 0) {
        if (storedAds[0].offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          storedAds[0].offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        let optList = MedicalcodesService.getAddressTypeList().filter(opt => adObj["address_type"] == opt.name);
        if (optList.length > 0) {
          storedAds[0].address_type = optList[0].value;
        }
        storedAds[0].street1 = adObj["street1"];
        storedAds[0].street2 = adObj["street2"];
        storedAds[0].city = adObj["city"];
        storedAds[0].postal_code = adObj["postal_code"];

        optList = this.appSvc.stateOptions.filter(opt => adObj["state_id"] == opt.name);
        if (optList.length > 0) {
          storedAds[0].state_id = optList[0].value;
        }

        optList = this.appSvc.countryOptions.filter(opt => adObj["country_id"] == opt.name);
        if (optList.length > 0) {
          storedAds[0].country_id = optList[0].value;
        }
      }
    }
  }

  updateContact(cons: contact[]) {
    for (let icon = 0; icon < this.contactDataSource.data.length; icon++) {
      let conObj = this.contactDataSource.data[icon];

      let storedCons = cons.filter(con => {
        return con.contact_key == conObj["contact_key"]
      });

      if (storedCons.length > 0) {
        if (storedCons[0].offline_record_status != IceTypes.offlineRecStatus.offlineInsert)
          storedCons[0].offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;

        let optList = MedicalcodesService.getContactTypeList().filter(opt => conObj["communication_type"] == opt.name);
        if (optList.length > 0) {
          storedCons[0].communication_type = optList[0].value;
        }

        optList = MedicalcodesService.getContactMethodList().filter(opt => conObj["communication_number_qualifier"] == opt.name);
        if (optList.length > 0) {
          storedCons[0].communication_number_qualifier = optList[0].value;
        }

        storedCons[0].communication_number = conObj["communication_number"];
      }
    }
  }

  updateProviders(): provider_index[] {
    let proary = [];
    let ctrl = this.surescriptsIDControls["UpdateDisable"];
    for (let ipro = 0; ipro < this.providersDataSource.data.length; ipro++) {
      let idxObj = this.providersDataSource.data[ipro];

      let start = idxObj["active_start_time"];
      let end = idxObj["active_end_time"];
      let updateDisable = idxObj["updatedisable"];
      let svcLevel = idxObj["changed_servicelevel"];
      let proIdx: provider_index = idxObj["object_reference"];
      if (proIdx != null) {
        proIdx.active_start_time = Iceutility.convertToUTCEx(start);
        proIdx.active_end_time = Iceutility.convertToUTCEx(end);
        if (updateDisable == this.providerUpdateDisplayValue || updateDisable === false)
          proIdx.updatedisable = true;
        else
          proIdx.updatedisable = false;
        proary.push(proIdx);

        proIdx.servicelevel = "";
        if (svcLevel != null) {
          proIdx.servicelevel = svcLevel;
        }
      }
    }
    return proary;
  }

  setNewOutboundApplicationList(domainType: IceTypes.ACCOUNT_TYPE, domain: string) {
    if (domain == null || domain.length == 0) return;

    switch (domainType) {
      case IceTypes.ACCOUNT_TYPE.actVendor: {
        this.getVendorService().getVendor(domain).subscribe(
          data => {
            if (data == null || data.length == 0) {
              this.getDomainService().logMessage(IceTypes.LOGTYPE.ltError, "The receiver of this outbound connection does not exist or an error occurred.");
              return;
            }

            let opts = [];
            let ven: vendor = data[0];
            for (let iconn = 0; iconn < ven.INCONNPARAMS.length; iconn++) {
              let conn: connectionparameters = ven.INCONNPARAMS[iconn];
              if (conn == null) continue;

              let name = conn.connection_title;
              let val = "";
              let storedTypes = ven.TYPES.filter(t => {
                return t.connection_parameters_key == conn.connection_parameters_key;
              });
              if (storedTypes.length > 0) {
                name += " (" + MessageService.getTransTypeDesc(storedTypes[0].trans_type_code) + ", Ver: " + storedTypes[0].protocol_api_version + ", " + conn.application_code + " " + (Iceutility.toBoolean(storedTypes[0].underdevelopment) ? "Testing..." : "Live...");
                val = conn.connection_parameters_key + "|" + storedTypes[0].trans_type_code.toString() + "|" + conn.application_code + "|" + storedTypes[0].protocol_api_version + "|" + storedTypes[0].test_required + "|" + storedTypes[0].underdevelopment + "|" + conn.connection_title;
                opts.push({ value: val, name: name });
              }
            }

            this.newOutboundDomainApplicaionCtrl.setOptions(opts);
          },
          error => {
            console.log(error);
          });
        break;
      }
    }
  }

  onAddNewOutboundConnection(conn: connectionparameters, typeref: transtypereference, destConns: connectionparameters[], destTyperef: transtypereference[]) {
    this.addNewOutboundDomainConnection(conn, typeref);
    destConns.push(conn);
    destTyperef.push(typeref);
    this.hideNewOutboundConnectionSection();
  }

  // Events
  onControlChange(event) {
    if (event.selectSettings != null) {
      switch (event.selectSettings.id) {
        case this.controlIDNewOutboundTypeofDomain: {
          let submitSec = this.getNewOutboundDomainSubmitSection();
          if (submitSec) submitSec.setShow(true);

          let ctrName: FormControl = this.getNewOutboundDomainTypeControl().getFormControl();
          if (ctrName != null) {
            this.setNewOutboundDomainNameList(<IceTypes.ACCOUNT_TYPE>ctrName.value);
          }
          break;
        }
        case this.controlIDNewOutboundAppofDomain: {
          break;
        }
      }
    }
    else if (event.autocompleteSettings != null) {
      switch (event.autocompleteSettings.id) {
        case this.controlIDNewOutboundNameofDomain: {
          let ctrType: FormControl = this.getNewOutboundDomainTypeControl().getFormControl();
          if (ctrType != null) {
            let ctrName: FormControl = event.autocompleteSettings.getFormControl();
            if (ctrName != null) {
              try {
                let nameObj = JSON.parse(ctrName.value);
                if (nameObj == null || nameObj.length == 0) throw "Invalid domain selection.";
                this.setNewOutboundApplicationList(<IceTypes.ACCOUNT_TYPE>ctrType.value, nameObj[0].value);
              }
              catch (e) {
                console.log(e);
              }
            }
          }
          break;
        }
      }
    }
    else if (event.buttonSettings != null) {
      switch (event.buttonSettings.id) {
        case "paymentstatus": {
          let paymentCtrl: IcecontrolSettings = event.buttonSettings;

          switch (event.buttonAction) {
            case "OptionChange": {
              paymentCtrl.properties.subTotal = 0.0;
              paymentCtrl.properties.otherFees = 0.0;
              paymentCtrl.properties.grandTotal = 0.0;
              paymentCtrl.properties.lastErrors = null;

              let opts: licenseobject[] = paymentCtrl.getOptions();
              for (let iLic = 0; iLic < opts.length; iLic++) {
                let licObj: licenseobject = opts[iLic];
                if (licObj == null) continue;

                // lic condition
                if (licObj.license_id == 1) {
                  // filter out licObj.COUNTRIES
                  paymentCtrl.properties.subTotal += Iceutility.toDouble(licObj.rate);
                }
              }

              // Set Total
              paymentCtrl.properties.grandTotal = Iceutility.toDouble(paymentCtrl.properties.otherFees) + paymentCtrl.properties.subTotal;
              break;
            }
          }
          break;
        }
      }
    }
  }

  onDefaultButtonClick(event, destConns: connectionparameters[], destTyperef: transtypereference[], otherData: any) {
    if (event.buttonSettings != null) {
      switch (event.buttonSettings.id) {
        // Outbound
        case this.controlIDAddNewOutboundConnection: {
          var newNetworkConnection = this.getNewOutboundDomainConnection();
          if (newNetworkConnection.conn && newNetworkConnection.typeref) {
            this.onAddNewOutboundConnection(newNetworkConnection.conn, newNetworkConnection.typeref, destConns, destTyperef);
          }
          break;
        }
        case this.controlIDAddNewOutboundConnectionCancel: {
          this.hideNewOutboundConnectionSection();
          break;
        }
        case this.controlIDEditOutboundConnectionSave: {
          this.editOutboundUpdate(true, otherData);
          this.hideEditOutboundConnectionSection();
          break;
        }
        case this.controlIDEditOutboundConnectionCancel: {
          otherData = null;
          this.hideEditOutboundConnectionSection();
          break;
        }
        // Inbound
        case this.controlIDEditInboundConnectionSave: {
          this.editInboundUpdate(true, otherData);
          this.hideEditInboundConnectionSection();
          break;
        }
        case this.controlIDEditInboundConnectionCancel: {
          otherData = null;
          this.hideEditInboundConnectionSection();
          break;
        }
        case "paymentstatus": {
          switch (event.buttonAction) {
            case "CancelPayment": {
              this.cancelPayment(event);
              break;
            }
            case "ProcessPayment": {
              this.processPayment(event);
              break;
            }
          }
          break;
        }
        case "paymentreceipt": {
          switch (event.buttonAction) {
            case "CloseReceipt": {
              this.appSvc.hideEditPanelSection(this.sectionTagPaymentReceipt);
              break;
            }
          }
          break;
        }
        default: {          
          this.appSvc.processEditPanelSectionButtons(this.sectionTagEditContact, event.buttonSettings.id);
          this.appSvc.processEditPanelSectionButtons(this.sectionTagEditAddress, event.buttonSettings.id);
          this.appSvc.processEditPanelSectionButtons(this.sectionTagEditIdentification, event.buttonSettings.id);
          let proRowData = this.appSvc.getEditPanelSectionRow(this.sectionTagEditPracticeProvider);
          this.appSvc.processEditPanelSectionButtons(this.sectionTagEditPracticeProvider, event.buttonSettings.id);

          if (proRowData["updatedisable"] == true)
            proRowData["updatedisable"] = this.providerUpdateDisplayValue;
          else
            proRowData["updatedisable"] = this.providerDisableDisplayValue;

          let svcLevels: string = proRowData["servicelevel"];
          if (svcLevels != null) {
            try {
              let svcLvlObject = JSON.parse(svcLevels);
              if (svcLvlObject != null) {
                let services = [];
                let values = [];

                for (let isvc = 0; isvc < svcLvlObject.length; isvc++) {
                  let svc = svcLvlObject[isvc];
                  if (svc == null) continue;
                  services.push(svc.name);
                  values.push(svc.value);
                }
                proRowData["servicelevel"] = services.join(",");
                proRowData["changed_servicelevel"] = values.join(",");
              }
            }
            catch (e) {
              proRowData["servicelevel"] = "";
              proRowData["changed_servicelevel"] = "";
              console.log(e);
            }
          }

          break;
        }
      }
    }

    if (event.controlSettings != null) {
      switch (event.controlSettings.id) {
        case this.controlIDTaxonomyCode: {
          // Flip the select back to value as the taxonomy code so that the DDL selected is correct
          let optList = this.taxonomyCodeCtrl.getOptions().filter(opt => this.taxonomyCodeCtrl.getFormControl().value == opt.name);
          if (optList.length > 0) {
            this.taxonomyCodeCtrl.getFormControl().setValue(optList[0].value);
          }
          break;
        }
      }
    }
  }

  public onRowClick(event) {
    if (event.matTableSettings != null && event.rowData != null) {
      switch (event.matTableSettings.tag) {
        case this.tableTagOutboundNetworkConnectionTable: {
          let ctrlPerm = this.getAppService().getPermission(userTypes.USER_FEATURES.ufX12NSearch);
          if (ctrlPerm != null && ctrlPerm.default_access == userTypes.USER_FEATURE_ACCESS.ufaFullControl) {
            try {
              let submitSec = this.getEditOutboundDomainSubmitSection();
              if (submitSec) submitSec.setShow(true);
              this.editOutboundUpdate(false, event.rowData);
            }
            catch (e) {
              console.log(e);
            }
          }
          break;
        }
        case this.tableTagInboundNetworkConnectionTable: {
          let ctrlPerm = this.getAppService().getPermission(userTypes.USER_FEATURES.ufX12NSearch);
          if (ctrlPerm != null && ctrlPerm.default_access == userTypes.USER_FEATURE_ACCESS.ufaFullControl) {
            try {
              let submitSec = this.getEditInboundDomainSubmitSection();
              if (submitSec) submitSec.setShow(true);
              this.editInboundUpdate(false, event.rowData);
            }
            catch (e) {
              console.log(e);
            }
          }
          break;
        }
        case this.tableTagIdentification: {
          let ctrlPerm = this.getAppService().getPermission(userTypes.USER_FEATURES.ufIdentification);
          if (ctrlPerm != null && ctrlPerm.default_access == userTypes.USER_FEATURE_ACCESS.ufaFullControl) {
            this.appSvc.showEditPanelSection(this.sectionTagEditIdentification);
            this.appSvc.editPanelSectionUpdate(this.sectionTagEditIdentification, false, event.rowData);
          }
          break;
        }
        case this.tableTagAddress: {
          let ctrlPerm = this.getAppService().getPermission(userTypes.USER_FEATURES.ufSetup);
          if (ctrlPerm != null && ctrlPerm.default_access == userTypes.USER_FEATURE_ACCESS.ufaFullControl) {
            this.appSvc.showEditPanelSection(this.sectionTagEditAddress);
            this.appSvc.editPanelSectionUpdate(this.sectionTagEditAddress, false, event.rowData);
          }
          break;
        }
        case this.tableTagContact: {
          let ctrlPerm = this.getAppService().getPermission(userTypes.USER_FEATURES.ufSetup);
          if (ctrlPerm != null && ctrlPerm.default_access == userTypes.USER_FEATURE_ACCESS.ufaFullControl) {
            this.appSvc.showEditPanelSection(this.sectionTagEditContact);
            this.appSvc.editPanelSectionUpdate(this.sectionTagEditContact, false, event.rowData);
          }
          break;
        }
        case this.tableTagNetworkInformation: {
          // To do this will be for general network information
          //let ctrlPerm = this.getAppService().getPermission(userTypes.USER_FEATURES.ufSetup);
          //if (ctrlPerm != null && ctrlPerm.default_access == userTypes.USER_FEATURE_ACCESS.ufaFullControl) {
          //  this.appSvc.showEditPanelSection(this.sectionTagEditNetworkInformation);
          //  this.appSvc.editPanelSectionUpdate(this.sectionTagEditNetworkInformation, false, event.rowData);
          //}
          break;
        }
        case this.tableTagPracticeProvider: {
          let ctrlPerm = this.getAppService().getPermission(userTypes.USER_FEATURES.ufSetup);
          if (ctrlPerm != null && ctrlPerm.default_access == userTypes.USER_FEATURE_ACCESS.ufaFullControl) {
            if (event.rowData["updatedisable"] == this.providerUpdateDisplayValue)
              event.rowData["updatedisable"] = true;
            else
              event.rowData["updatedisable"] = false;

            let svclevels = [];
            let lvlDesc: string = event.rowData["changed_servicelevel"];
            let lvlParts = lvlDesc == null || lvlDesc.length == 0 ? [] : lvlDesc.split(",");
            for (let ilvl = 0; ilvl < lvlParts.length; ilvl++) {
              svclevels.push({
                name: OrderService.getServiceLevel(<IceTypes.ServiceLevel>Iceutility.toLong(lvlParts[ilvl])),
                value: <IceTypes.ServiceLevel>Iceutility.toLong(lvlParts[ilvl])
              });
            }

            event.rowData["servicelevel"] = JSON.stringify(svclevels);

            this.appSvc.showEditPanelSection(this.sectionTagEditPracticeProvider);
            this.appSvc.editPanelSectionUpdate(this.sectionTagEditPracticeProvider, false, event.rowData);
          }
          break;
        }
      }
    }
  }

  public onDefaultAddRowButtonClick(event,
    destCons: contact[],
    destAds: address[],
    destIds: identification[],
    destConns: connectionparameters[],
    destTyperef: transtypereference[],
    destInConns: connectionparameters[],
    destTypes: transtype[]) {

    if (event.matTableSettings != null) {
      switch (event.matTableSettings.tag) {
        case this.tableTagContact: {
          try {
            let con = new contact();
            con.contact_key = Iceutility.guid(true);
            con.communication_number_qualifier = "TE";
            con.communication_number = "";
            destCons.push(con);
            this.addNewContact(con);
          }
          catch (e) {
            console.log(e);
          }
          break;
        }
        case this.tableTagAddress: {
          try {
            let adr = new address();
            adr.address_key = Iceutility.guid(true);
            adr.address_type = IceTypes.addresstype.atWork;
            adr.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
            destAds.push(adr);
            this.addNewAddress(adr);
          }
          catch (e) {
            console.log(e);
          }
          break;
        }
        case this.tableTagIdentification: {
          try {
            let ident = new identification();
            ident.identification_key = Iceutility.guid(true);
            ident.identification_code_qualifier = this.IDSelectType;
            ident.identification_code = "";
            ident.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
            destIds.push(ident);
            this.addNewIdentification(ident);
          }
          catch (e) {
            console.log(e);
          }
          break;
        }
        case this.tableTagSubscription: {
          this.appSvc.showEditPanelSection(this.sectionTagSubscriptionPayment);
          this.appSvc.hideEditPanelSection(this.sectionTagPaymentReceipt);
          this.appSvc.editPanelSectionUpdate(this.sectionTagSubscriptionPayment, false, {});
          break;
        }
        case this.tableTagInboundNetworkConnectionTable: {
          let conn = null;
          let type = null;
          try {
            conn = new connectionparameters();
            conn.connection_parameters_key = Iceutility.guid(true);
            conn.account_type = this.getAppService().getCurrentAccountType();
            conn.trans_account = this.getAppService().getCurrentAccount();
            conn.connection_title = "";
            conn.server_user_name = "";
            conn.server_password = "";
            conn.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
            type = new transtype();
            type.trans_type_key = Iceutility.guid(true);
            type.connection_parameters_key = conn.connection_parameters_key;
            type.trans_type_code = IceTypes.TRANSTYPE.itNone;
            type.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
            destInConns.push(conn);
            destTypes.push(type);
            this.addNewInboundDomainConnection(conn, type);
          }
          catch (e) {
            console.log(e);
          }
          break;
        }
      }
    }
  }

  onDefaultRowActionClick(event) {
    if (event.actionItem == null) return;

    let entry = event["rowData"];
    if (entry == null) {
      // To do log error
      return;
    }

    if (IceTypes.recordQuickActionCloudDownload.value == event.actionItem.value) {
      let proIdx: provider_index = <provider_index>entry;
      // Set loader show
      this.getProviderService().getHIEProvider(this.getAppService().getCurrentAccount(), this.getAppService().getCurrentAccountType(), proIdx.trans_account).subscribe(
        data => {
          // Set loader hide
        },
        error => {
          // Set loader hide
          console.log(error);
        });
    }
  }

  processPayment(event) {
    // build the order
    this.messageSvc.logMessage(IceTypes.LOGTYPE.ltUserAlert, "processing...");
    let paymentSection: IcepanelsectionSettings = this.appSvc.getEditPanelSection(this.sectionTagSubscriptionPayment);
    let paymentCtrl: IcecontrolSettings = event.buttonSettings;
    let paymentControlGroup: FormGroup = event.paymentGroup;
    let ord: orderobject = new orderobject();
    ord.PAYMENT_REQUEST = [new paymentrequest()];
    let userInfo = this.loginSvc.GetSessionUserInfo();
    ord.login_user_name = this.loginSvc.GetUserName(userInfo, false);
    ord.trans_account = this.appSvc.getCurrentAccount();
    ord.account_type = this.appSvc.getCurrentAccountType();
    ord.customer_contact_name = this.profileContactName;
    ord.customer_company_name = this.profileCompanyName;
    ord.customer_address = this.profileAddress;
    ord.customer_city = this.profileCity;
    ord.customer_state = this.profileState;
    ord.customer_postal_code = this.profilePostalCode;
    ord.customer_province = this.profileProvince;
    ord.customer_country_code = this.profileCountryCode;
    ord.customer_phone = this.profilePhone;
    ord.customer_email = this.profileEmail;
    ord.customer_currency_code = this.profileCurrencyCode;

    ord.sub_total = paymentCtrl.properties.subTotal;
    ord.other_fees = paymentCtrl.properties.otherFees;
    ord.total = paymentCtrl.properties.grandTotal;

    let opts: licenseobject[] = paymentCtrl.getOptions();
    for (let iLic = 0; iLic < opts.length; iLic++) {
      let licObj: licenseobject = opts[iLic];
      if (licObj == null) continue;

      if (licObj.license_id == 1) { // To do subscriptionobject type are existing subs and licenseobject are new
        let sub: subscriptionobject = <subscriptionobject>licObj;
        sub.subscription_key = ""; // Reseting this to empty

        let orddtl: orderdetailobject = new orderdetailobject();
        orddtl.order_detail_key = Iceutility.guid(true);
        orddtl.trans_account = this.appSvc.getCurrentAccount();
        orddtl.account_type = this.appSvc.getCurrentAccountType();
        orddtl.quantity = 1.0;
        orddtl.price = sub.rate;
        orddtl.SUBSCRIPTOBJ.push(sub);
        ord.ORDER_DETAILS.push(orddtl);
      }
    }

    ord.PAYMENT_REQUEST[0].transactiontype = "authCaptureTransaction";
    ord.PAYMENT_REQUEST[0].paymentmethod = paymentControlGroup.get("paymentMethod").value
    ord.PAYMENT_REQUEST[0].cardnumber = paymentControlGroup.get("cardNumber").value;
    ord.PAYMENT_REQUEST[0].expirationdate = paymentControlGroup.get("cardExpires").value;
    ord.PAYMENT_REQUEST[0].cardcode = paymentControlGroup.get("cardCode").value;
    ord.PAYMENT_REQUEST[0].invoicenumber = "";
    ord.PAYMENT_REQUEST[0].invoicedescription = "ICEMEDX Subscription(s)";

    let cardHolder = paymentControlGroup.get("cardHolder").value;
    let first = "", last = "";
    let parts = cardHolder.split(" ");
    if (parts.length > 0)
      first = parts[0];

    if (parts.length > 1)
      last = parts[1];

    ord.PAYMENT_REQUEST[0].firstname = first;
    ord.PAYMENT_REQUEST[0].lastname = last;

    ord.PAYMENT_REQUEST[0].bankaccounttype = paymentControlGroup.get("bankAccountType").value;
    ord.PAYMENT_REQUEST[0].bankname = paymentControlGroup.get("bankName").value;
    ord.PAYMENT_REQUEST[0].bankroutingnumber = paymentControlGroup.get("bankRoutingNumber").value;
    ord.PAYMENT_REQUEST[0].bankaccountnumber = paymentControlGroup.get("bankAccountNumber").value;
    ord.PAYMENT_REQUEST[0].nameonaccount = paymentControlGroup.get("bankAccountHolder").value;
    this.messageSvc.logMessage(IceTypes.LOGTYPE.ltUserAlert, "order object prepared...");

    paymentSection.setLoading(true);
    paymentSection.setShow(false);
    this.subTable.showAddButton(false);
    this.getDomainService().processPayment(ord).subscribe(
      data => {
        paymentSection.setLoading(false);
        paymentSection.setShow(true);
        this.subTable.showAddButton(true);
        this.messageSvc.logMessage(IceTypes.LOGTYPE.ltUserAlert, "process payment API invoked...");
        if (data == null || data.length == 0) {
          // To do log error
          this.messageSvc.logMessage(IceTypes.LOGTYPE.ltError, "Failed to process your request.");
          return;
        }

        if (this.subscriptionDataSource.data == null)
          this.subscriptionDataSource.data = [];

        let transRes = null;

        for (let iord = 0; iord < data.length; iord++) {
          let ordObj: orderobject = data[iord];
          if (ordObj == null) continue;

          for (let idtl = 0; idtl < ordObj.ORDER_DETAILS.length; idtl++) {
            let dtl = ordObj.ORDER_DETAILS[idtl];
            if (dtl == null || dtl.SUBSCRIPTOBJ == null || dtl.SUBSCRIPTOBJ.length == 0) continue;

            let subsFound = this.subscriptionDataSource.data.filter(s => s.subscription_key == dtl.subscription_key);
            if (subsFound.length > 0) {
              // To do update payment status
            }
            else {
              let dt = null;
              if (!isNaN(dtl.SUBSCRIPTOBJ[0].date_renewed))
                dt = dtl.SUBSCRIPTOBJ[0].date_renewed;
              else
                dt = dtl.SUBSCRIPTOBJ[0].inception_date;

              let subObj = {
                title: dtl.SUBSCRIPTOBJ[0].title,
                features: dtl.SUBSCRIPTOBJ[0].features,
                summary: dtl.SUBSCRIPTOBJ[0].getSummary().join(";"),
                date: Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(dt)),
                rate: dtl.SUBSCRIPTOBJ[0].rate.toString() + " " + dtl.SUBSCRIPTOBJ[0].currency_code,
                subscription_key: dtl.SUBSCRIPTOBJ[0].subscription_key
              };

              this.subscriptionDataSource.data.push(subObj)
            }
          }

          if (transRes == null) {
            try {
              transRes = JSON.parse(ordObj.payment_response);
            }
            catch (e) {
              this.messageSvc.logMessage(IceTypes.LOGTYPE.ltUserAlert, "API success. Error during response processing.");
              console.log(e);
            }
          }
        }

        this.subscriptionDataSource.data = this.subscriptionDataSource.data;
        this.appSvc.hideEditPanelSection(this.sectionTagSubscriptionPayment);
        let receiptSection: IcepanelsectionSettings = this.appSvc.getEditPanelSection(this.sectionTagPaymentReceipt);
        if (receiptSection) {
          let ctrls = receiptSection.controls.filter(c => c.controlName == "paymentreceipt");
          if (ctrls.length > 0) {
            ctrls[0].properties.orderInformation = data[0];
            ctrls[0].properties.transactionInformation = transRes;
            receiptSection.setShow(true);
          }
        }

        // Reset licenses
        paymentCtrl.properties.subTotal = 0.0;
        paymentCtrl.properties.otherFees = 0.0;
        paymentCtrl.properties.grandTotal = 0.0;
        paymentCtrl.properties.lastErrors = null;
        for (let iLic = 0; iLic < opts.length; iLic++) {
          let licObj: licenseobject = opts[iLic];
          if (licObj == null) continue;

          licObj.license_id = -1;
        }
        this.messageSvc.logMessage(IceTypes.LOGTYPE.ltUserAlert, "processing done");
      },
      error => {
        paymentSection.setLoading(false);
        paymentSection.setShow(true);
        this.subTable.showAddButton(true);

        // First lets do the basic error then try the full object
        let msg = "";
        if (error.statusText != null)
          msg += error.statusText;

        if (error.status != null)
          msg += " (" + error.status + ").";

        msg += "Make sure to complete the payment information using first and last name, and bank card or account information."
        this.getDomainService().logMessage(IceTypes.LOGTYPE.ltError, msg);

        var logrpt = new LogReport();
        var logmsg = new logmessage();
        logmsg.logtype = IceTypes.LOGTYPE.ltError;
        logmsg.message = msg;
        logrpt.LOGS.push(logmsg);
        var logrpts = [logrpt];

        paymentCtrl.properties.lastErrors = {
          requestUrl: null,
          logReports: logrpts,
          genericErrors: null
        };

        let errObj = this.getDomainService().getLastErrors();
        if (errObj != null && errObj.logReports != null) {
          try {
            console.log(JSON.stringify(errObj));
            paymentCtrl.properties.lastErrors = errObj;
          }
          catch (loge) {
            // fall through
          }
        }
      });
  }

  cancelPayment(event) {
    let paymentCtrl: IcecontrolSettings = event.buttonSettings;
    paymentCtrl.properties.subTotal = 0.0;
    paymentCtrl.properties.otherFees = 0.0;
    paymentCtrl.properties.grandTotal = 0.0;

    let opts: licenseobject[] = paymentCtrl.getOptions();
    for (let iLic = 0; iLic < opts.length; iLic++) {
      let licObj: licenseobject = opts[iLic];
      if (licObj == null) continue;

      licObj.license_id = -1;
    }
    this.appSvc.hideEditPanelSection(this.sectionTagSubscriptionPayment);
  }
}
